import { __assign, __awaiter, __generator, __read } from "tslib";
import { HttpRequest as __HttpRequest } from "@aws-sdk/protocol-http";
import { extendedEncodeURIComponent as __extendedEncodeURIComponent } from "@aws-sdk/smithy-client";
export var serializeAws_restJson1_1CreateAppCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps";
                if (input.CreateApplicationRequest !== undefined) {
                    body = serializeAws_restJson1_1CreateApplicationRequest(input.CreateApplicationRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1CreateCampaignCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/campaigns";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.WriteCampaignRequest !== undefined) {
                    body = serializeAws_restJson1_1WriteCampaignRequest(input.WriteCampaignRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1CreateEmailTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/templates/{TemplateName}/email";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                if (input.EmailTemplateRequest !== undefined) {
                    body = serializeAws_restJson1_1EmailTemplateRequest(input.EmailTemplateRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1CreateExportJobCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/jobs/export";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.ExportJobRequest !== undefined) {
                    body = serializeAws_restJson1_1ExportJobRequest(input.ExportJobRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1CreateImportJobCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/jobs/import";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.ImportJobRequest !== undefined) {
                    body = serializeAws_restJson1_1ImportJobRequest(input.ImportJobRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1CreateJourneyCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/journeys";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.WriteJourneyRequest !== undefined) {
                    body = serializeAws_restJson1_1WriteJourneyRequest(input.WriteJourneyRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1CreatePushTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/templates/{TemplateName}/push";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                if (input.PushNotificationTemplateRequest !== undefined) {
                    body = serializeAws_restJson1_1PushNotificationTemplateRequest(input.PushNotificationTemplateRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1CreateSegmentCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/segments";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.WriteSegmentRequest !== undefined) {
                    body = serializeAws_restJson1_1WriteSegmentRequest(input.WriteSegmentRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1CreateSmsTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/templates/{TemplateName}/sms";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                if (input.SMSTemplateRequest !== undefined) {
                    body = serializeAws_restJson1_1SMSTemplateRequest(input.SMSTemplateRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1CreateVoiceTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/templates/{TemplateName}/voice";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                if (input.VoiceTemplateRequest !== undefined) {
                    body = serializeAws_restJson1_1VoiceTemplateRequest(input.VoiceTemplateRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteAdmChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/adm";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteApnsChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/apns";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteApnsSandboxChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/apns_sandbox";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteApnsVoipChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/apns_voip";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteApnsVoipSandboxChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/apns_voip_sandbox";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteAppCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteBaiduChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/baidu";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteCampaignCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/campaigns/{CampaignId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.CampaignId !== undefined) {
                    labelValue = input.CampaignId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: CampaignId.");
                    }
                    resolvedPath = resolvedPath.replace("{CampaignId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: CampaignId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteEmailChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/email";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteEmailTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/templates/{TemplateName}/email";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                query = __assign({}, (input.Version !== undefined && { version: input.Version }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteEndpointCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/endpoints/{EndpointId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.EndpointId !== undefined) {
                    labelValue = input.EndpointId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: EndpointId.");
                    }
                    resolvedPath = resolvedPath.replace("{EndpointId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: EndpointId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteEventStreamCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/eventstream";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteGcmChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/gcm";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteJourneyCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/journeys/{JourneyId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.JourneyId !== undefined) {
                    labelValue = input.JourneyId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: JourneyId.");
                    }
                    resolvedPath = resolvedPath.replace("{JourneyId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: JourneyId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeletePushTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/templates/{TemplateName}/push";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                query = __assign({}, (input.Version !== undefined && { version: input.Version }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteSegmentCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/segments/{SegmentId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.SegmentId !== undefined) {
                    labelValue = input.SegmentId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: SegmentId.");
                    }
                    resolvedPath = resolvedPath.replace("{SegmentId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: SegmentId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteSmsChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/sms";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteSmsTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/templates/{TemplateName}/sms";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                query = __assign({}, (input.Version !== undefined && { version: input.Version }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteUserEndpointsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/users/{UserId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.UserId !== undefined) {
                    labelValue = input.UserId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: UserId.");
                    }
                    resolvedPath = resolvedPath.replace("{UserId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: UserId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteVoiceChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/voice";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1DeleteVoiceTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/templates/{TemplateName}/voice";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                query = __assign({}, (input.Version !== undefined && { version: input.Version }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetAdmChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/adm";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetApnsChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/apns";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetApnsSandboxChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/apns_sandbox";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetApnsVoipChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/apns_voip";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetApnsVoipSandboxChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/apns_voip_sandbox";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetAppCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetApplicationDateRangeKpiCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/kpis/daterange/{KpiName}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.KpiName !== undefined) {
                    labelValue = input.KpiName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: KpiName.");
                    }
                    resolvedPath = resolvedPath.replace("{KpiName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: KpiName.");
                }
                query = __assign(__assign(__assign(__assign({}, (input.EndTime !== undefined && {
                    "end-time": (input.EndTime.toISOString().split(".")[0] + "Z").toString()
                })), (input.NextToken !== undefined && { "next-token": input.NextToken })), (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.StartTime !== undefined && {
                    "start-time": (input.StartTime.toISOString().split(".")[0] + "Z").toString()
                }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetApplicationSettingsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/settings";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetAppsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps";
                query = __assign(__assign({}, (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.Token !== undefined && { token: input.Token }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetBaiduChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/baidu";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetCampaignCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/campaigns/{CampaignId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.CampaignId !== undefined) {
                    labelValue = input.CampaignId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: CampaignId.");
                    }
                    resolvedPath = resolvedPath.replace("{CampaignId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: CampaignId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetCampaignActivitiesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/campaigns/{CampaignId}/activities";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.CampaignId !== undefined) {
                    labelValue = input.CampaignId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: CampaignId.");
                    }
                    resolvedPath = resolvedPath.replace("{CampaignId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: CampaignId.");
                }
                query = __assign(__assign({}, (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.Token !== undefined && { token: input.Token }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetCampaignDateRangeKpiCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/campaigns/{CampaignId}/kpis/daterange/{KpiName}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.CampaignId !== undefined) {
                    labelValue = input.CampaignId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: CampaignId.");
                    }
                    resolvedPath = resolvedPath.replace("{CampaignId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: CampaignId.");
                }
                if (input.KpiName !== undefined) {
                    labelValue = input.KpiName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: KpiName.");
                    }
                    resolvedPath = resolvedPath.replace("{KpiName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: KpiName.");
                }
                query = __assign(__assign(__assign(__assign({}, (input.EndTime !== undefined && {
                    "end-time": (input.EndTime.toISOString().split(".")[0] + "Z").toString()
                })), (input.NextToken !== undefined && { "next-token": input.NextToken })), (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.StartTime !== undefined && {
                    "start-time": (input.StartTime.toISOString().split(".")[0] + "Z").toString()
                }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetCampaignVersionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/campaigns/{CampaignId}/versions/{Version}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.CampaignId !== undefined) {
                    labelValue = input.CampaignId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: CampaignId.");
                    }
                    resolvedPath = resolvedPath.replace("{CampaignId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: CampaignId.");
                }
                if (input.Version !== undefined) {
                    labelValue = input.Version;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: Version.");
                    }
                    resolvedPath = resolvedPath.replace("{Version}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: Version.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetCampaignVersionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/campaigns/{CampaignId}/versions";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.CampaignId !== undefined) {
                    labelValue = input.CampaignId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: CampaignId.");
                    }
                    resolvedPath = resolvedPath.replace("{CampaignId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: CampaignId.");
                }
                query = __assign(__assign({}, (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.Token !== undefined && { token: input.Token }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetCampaignsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/campaigns";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                query = __assign(__assign({}, (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.Token !== undefined && { token: input.Token }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetChannelsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetEmailChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/email";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetEmailTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/templates/{TemplateName}/email";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                query = __assign({}, (input.Version !== undefined && { version: input.Version }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetEndpointCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/endpoints/{EndpointId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.EndpointId !== undefined) {
                    labelValue = input.EndpointId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: EndpointId.");
                    }
                    resolvedPath = resolvedPath.replace("{EndpointId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: EndpointId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetEventStreamCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/eventstream";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetExportJobCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/jobs/export/{JobId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.JobId !== undefined) {
                    labelValue = input.JobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: JobId.");
                    }
                    resolvedPath = resolvedPath.replace("{JobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: JobId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetExportJobsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/jobs/export";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                query = __assign(__assign({}, (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.Token !== undefined && { token: input.Token }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetGcmChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/gcm";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetImportJobCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/jobs/import/{JobId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.JobId !== undefined) {
                    labelValue = input.JobId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: JobId.");
                    }
                    resolvedPath = resolvedPath.replace("{JobId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: JobId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetImportJobsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/jobs/import";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                query = __assign(__assign({}, (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.Token !== undefined && { token: input.Token }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetJourneyCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/journeys/{JourneyId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.JourneyId !== undefined) {
                    labelValue = input.JourneyId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: JourneyId.");
                    }
                    resolvedPath = resolvedPath.replace("{JourneyId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: JourneyId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetJourneyDateRangeKpiCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/journeys/{JourneyId}/kpis/daterange/{KpiName}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.JourneyId !== undefined) {
                    labelValue = input.JourneyId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: JourneyId.");
                    }
                    resolvedPath = resolvedPath.replace("{JourneyId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: JourneyId.");
                }
                if (input.KpiName !== undefined) {
                    labelValue = input.KpiName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: KpiName.");
                    }
                    resolvedPath = resolvedPath.replace("{KpiName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: KpiName.");
                }
                query = __assign(__assign(__assign(__assign({}, (input.EndTime !== undefined && {
                    "end-time": (input.EndTime.toISOString().split(".")[0] + "Z").toString()
                })), (input.NextToken !== undefined && { "next-token": input.NextToken })), (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.StartTime !== undefined && {
                    "start-time": (input.StartTime.toISOString().split(".")[0] + "Z").toString()
                }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetJourneyExecutionActivityMetricsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/journeys/{JourneyId}/activities/{JourneyActivityId}/execution-metrics";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.JourneyActivityId !== undefined) {
                    labelValue = input.JourneyActivityId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: JourneyActivityId.");
                    }
                    resolvedPath = resolvedPath.replace("{JourneyActivityId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: JourneyActivityId.");
                }
                if (input.JourneyId !== undefined) {
                    labelValue = input.JourneyId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: JourneyId.");
                    }
                    resolvedPath = resolvedPath.replace("{JourneyId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: JourneyId.");
                }
                query = __assign(__assign({}, (input.NextToken !== undefined && { "next-token": input.NextToken })), (input.PageSize !== undefined && { "page-size": input.PageSize }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetJourneyExecutionMetricsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/journeys/{JourneyId}/execution-metrics";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.JourneyId !== undefined) {
                    labelValue = input.JourneyId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: JourneyId.");
                    }
                    resolvedPath = resolvedPath.replace("{JourneyId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: JourneyId.");
                }
                query = __assign(__assign({}, (input.NextToken !== undefined && { "next-token": input.NextToken })), (input.PageSize !== undefined && { "page-size": input.PageSize }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetPushTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/templates/{TemplateName}/push";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                query = __assign({}, (input.Version !== undefined && { version: input.Version }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetSegmentCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/segments/{SegmentId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.SegmentId !== undefined) {
                    labelValue = input.SegmentId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: SegmentId.");
                    }
                    resolvedPath = resolvedPath.replace("{SegmentId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: SegmentId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetSegmentExportJobsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/segments/{SegmentId}/jobs/export";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.SegmentId !== undefined) {
                    labelValue = input.SegmentId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: SegmentId.");
                    }
                    resolvedPath = resolvedPath.replace("{SegmentId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: SegmentId.");
                }
                query = __assign(__assign({}, (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.Token !== undefined && { token: input.Token }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetSegmentImportJobsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/segments/{SegmentId}/jobs/import";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.SegmentId !== undefined) {
                    labelValue = input.SegmentId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: SegmentId.");
                    }
                    resolvedPath = resolvedPath.replace("{SegmentId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: SegmentId.");
                }
                query = __assign(__assign({}, (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.Token !== undefined && { token: input.Token }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetSegmentVersionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/segments/{SegmentId}/versions/{Version}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.SegmentId !== undefined) {
                    labelValue = input.SegmentId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: SegmentId.");
                    }
                    resolvedPath = resolvedPath.replace("{SegmentId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: SegmentId.");
                }
                if (input.Version !== undefined) {
                    labelValue = input.Version;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: Version.");
                    }
                    resolvedPath = resolvedPath.replace("{Version}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: Version.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetSegmentVersionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/segments/{SegmentId}/versions";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.SegmentId !== undefined) {
                    labelValue = input.SegmentId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: SegmentId.");
                    }
                    resolvedPath = resolvedPath.replace("{SegmentId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: SegmentId.");
                }
                query = __assign(__assign({}, (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.Token !== undefined && { token: input.Token }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetSegmentsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/segments";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                query = __assign(__assign({}, (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.Token !== undefined && { token: input.Token }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetSmsChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/sms";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetSmsTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/templates/{TemplateName}/sms";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                query = __assign({}, (input.Version !== undefined && { version: input.Version }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetUserEndpointsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/users/{UserId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.UserId !== undefined) {
                    labelValue = input.UserId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: UserId.");
                    }
                    resolvedPath = resolvedPath.replace("{UserId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: UserId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetVoiceChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/voice";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1GetVoiceTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/templates/{TemplateName}/voice";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                query = __assign({}, (input.Version !== undefined && { version: input.Version }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1ListJourneysCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/apps/{ApplicationId}/journeys";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                query = __assign(__assign({}, (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.Token !== undefined && { token: input.Token }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1ListTagsForResourceCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/tags/{ResourceArn}";
                if (input.ResourceArn !== undefined) {
                    labelValue = input.ResourceArn;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ResourceArn.");
                    }
                    resolvedPath = resolvedPath.replace("{ResourceArn}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ResourceArn.");
                }
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1ListTemplateVersionsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/templates/{TemplateName}/{TemplateType}/versions";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                if (input.TemplateType !== undefined) {
                    labelValue = input.TemplateType;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateType.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateType}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateType.");
                }
                query = __assign(__assign({}, (input.NextToken !== undefined && { "next-token": input.NextToken })), (input.PageSize !== undefined && { "page-size": input.PageSize }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1ListTemplatesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/templates";
                query = __assign(__assign(__assign(__assign({}, (input.NextToken !== undefined && { "next-token": input.NextToken })), (input.PageSize !== undefined && { "page-size": input.PageSize })), (input.Prefix !== undefined && { prefix: input.Prefix })), (input.TemplateType !== undefined && {
                    "template-type": input.TemplateType
                }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "GET",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1PhoneNumberValidateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/phone/number/validate";
                if (input.NumberValidateRequest !== undefined) {
                    body = serializeAws_restJson1_1NumberValidateRequest(input.NumberValidateRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1PutEventStreamCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/eventstream";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.WriteEventStream !== undefined) {
                    body = serializeAws_restJson1_1WriteEventStream(input.WriteEventStream, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1PutEventsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/events";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.EventsRequest !== undefined) {
                    body = serializeAws_restJson1_1EventsRequest(input.EventsRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1RemoveAttributesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/attributes/{AttributeType}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.AttributeType !== undefined) {
                    labelValue = input.AttributeType;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: AttributeType.");
                    }
                    resolvedPath = resolvedPath.replace("{AttributeType}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: AttributeType.");
                }
                if (input.UpdateAttributesRequest !== undefined) {
                    body = serializeAws_restJson1_1UpdateAttributesRequest(input.UpdateAttributesRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1SendMessagesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/messages";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.MessageRequest !== undefined) {
                    body = serializeAws_restJson1_1MessageRequest(input.MessageRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1SendUsersMessagesCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/users-messages";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.SendUsersMessageRequest !== undefined) {
                    body = serializeAws_restJson1_1SendUsersMessageRequest(input.SendUsersMessageRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1TagResourceCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/tags/{ResourceArn}";
                if (input.ResourceArn !== undefined) {
                    labelValue = input.ResourceArn;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ResourceArn.");
                    }
                    resolvedPath = resolvedPath.replace("{ResourceArn}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ResourceArn.");
                }
                if (input.TagsModel !== undefined) {
                    body = serializeAws_restJson1_1TagsModel(input.TagsModel, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UntagResourceCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": ""
                };
                resolvedPath = "/v1/tags/{ResourceArn}";
                if (input.ResourceArn !== undefined) {
                    labelValue = input.ResourceArn;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ResourceArn.");
                    }
                    resolvedPath = resolvedPath.replace("{ResourceArn}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ResourceArn.");
                }
                query = __assign({}, (input.TagKeys !== undefined && {
                    tagKeys: (input.TagKeys || []).map(function (_entry) { return _entry; })
                }));
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "DELETE",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateAdmChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/adm";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.ADMChannelRequest !== undefined) {
                    body = serializeAws_restJson1_1ADMChannelRequest(input.ADMChannelRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateApnsChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/apns";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.APNSChannelRequest !== undefined) {
                    body = serializeAws_restJson1_1APNSChannelRequest(input.APNSChannelRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateApnsSandboxChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/apns_sandbox";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.APNSSandboxChannelRequest !== undefined) {
                    body = serializeAws_restJson1_1APNSSandboxChannelRequest(input.APNSSandboxChannelRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateApnsVoipChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/apns_voip";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.APNSVoipChannelRequest !== undefined) {
                    body = serializeAws_restJson1_1APNSVoipChannelRequest(input.APNSVoipChannelRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateApnsVoipSandboxChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/apns_voip_sandbox";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.APNSVoipSandboxChannelRequest !== undefined) {
                    body = serializeAws_restJson1_1APNSVoipSandboxChannelRequest(input.APNSVoipSandboxChannelRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateApplicationSettingsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/settings";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.WriteApplicationSettingsRequest !== undefined) {
                    body = serializeAws_restJson1_1WriteApplicationSettingsRequest(input.WriteApplicationSettingsRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateBaiduChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/baidu";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.BaiduChannelRequest !== undefined) {
                    body = serializeAws_restJson1_1BaiduChannelRequest(input.BaiduChannelRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateCampaignCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/campaigns/{CampaignId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.CampaignId !== undefined) {
                    labelValue = input.CampaignId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: CampaignId.");
                    }
                    resolvedPath = resolvedPath.replace("{CampaignId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: CampaignId.");
                }
                if (input.WriteCampaignRequest !== undefined) {
                    body = serializeAws_restJson1_1WriteCampaignRequest(input.WriteCampaignRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateEmailChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/email";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.EmailChannelRequest !== undefined) {
                    body = serializeAws_restJson1_1EmailChannelRequest(input.EmailChannelRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateEmailTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/templates/{TemplateName}/email";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                query = __assign(__assign({}, (input.CreateNewVersion !== undefined && {
                    "create-new-version": input.CreateNewVersion.toString()
                })), (input.Version !== undefined && { version: input.Version }));
                if (input.EmailTemplateRequest !== undefined) {
                    body = serializeAws_restJson1_1EmailTemplateRequest(input.EmailTemplateRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateEndpointCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/endpoints/{EndpointId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.EndpointId !== undefined) {
                    labelValue = input.EndpointId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: EndpointId.");
                    }
                    resolvedPath = resolvedPath.replace("{EndpointId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: EndpointId.");
                }
                if (input.EndpointRequest !== undefined) {
                    body = serializeAws_restJson1_1EndpointRequest(input.EndpointRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateEndpointsBatchCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/endpoints";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.EndpointBatchRequest !== undefined) {
                    body = serializeAws_restJson1_1EndpointBatchRequest(input.EndpointBatchRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateGcmChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/gcm";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.GCMChannelRequest !== undefined) {
                    body = serializeAws_restJson1_1GCMChannelRequest(input.GCMChannelRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateJourneyCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/journeys/{JourneyId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.JourneyId !== undefined) {
                    labelValue = input.JourneyId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: JourneyId.");
                    }
                    resolvedPath = resolvedPath.replace("{JourneyId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: JourneyId.");
                }
                if (input.WriteJourneyRequest !== undefined) {
                    body = serializeAws_restJson1_1WriteJourneyRequest(input.WriteJourneyRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateJourneyStateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/journeys/{JourneyId}/state";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.JourneyId !== undefined) {
                    labelValue = input.JourneyId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: JourneyId.");
                    }
                    resolvedPath = resolvedPath.replace("{JourneyId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: JourneyId.");
                }
                if (input.JourneyStateRequest !== undefined) {
                    body = serializeAws_restJson1_1JourneyStateRequest(input.JourneyStateRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdatePushTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/templates/{TemplateName}/push";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                query = __assign(__assign({}, (input.CreateNewVersion !== undefined && {
                    "create-new-version": input.CreateNewVersion.toString()
                })), (input.Version !== undefined && { version: input.Version }));
                if (input.PushNotificationTemplateRequest !== undefined) {
                    body = serializeAws_restJson1_1PushNotificationTemplateRequest(input.PushNotificationTemplateRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateSegmentCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/segments/{SegmentId}";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.SegmentId !== undefined) {
                    labelValue = input.SegmentId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: SegmentId.");
                    }
                    resolvedPath = resolvedPath.replace("{SegmentId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: SegmentId.");
                }
                if (input.WriteSegmentRequest !== undefined) {
                    body = serializeAws_restJson1_1WriteSegmentRequest(input.WriteSegmentRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateSmsChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/sms";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.SMSChannelRequest !== undefined) {
                    body = serializeAws_restJson1_1SMSChannelRequest(input.SMSChannelRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateSmsTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/templates/{TemplateName}/sms";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                query = __assign(__assign({}, (input.CreateNewVersion !== undefined && {
                    "create-new-version": input.CreateNewVersion.toString()
                })), (input.Version !== undefined && { version: input.Version }));
                if (input.SMSTemplateRequest !== undefined) {
                    body = serializeAws_restJson1_1SMSTemplateRequest(input.SMSTemplateRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateTemplateActiveVersionCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/templates/{TemplateName}/{TemplateType}/active-version";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                if (input.TemplateType !== undefined) {
                    labelValue = input.TemplateType;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateType.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateType}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateType.");
                }
                if (input.TemplateActiveVersionRequest !== undefined) {
                    body = serializeAws_restJson1_1TemplateActiveVersionRequest(input.TemplateActiveVersionRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateVoiceChannelCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/apps/{ApplicationId}/channels/voice";
                if (input.ApplicationId !== undefined) {
                    labelValue = input.ApplicationId;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: ApplicationId.");
                    }
                    resolvedPath = resolvedPath.replace("{ApplicationId}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: ApplicationId.");
                }
                if (input.VoiceChannelRequest !== undefined) {
                    body = serializeAws_restJson1_1VoiceChannelRequest(input.VoiceChannelRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        body: body
                    })];
        }
    });
}); };
export var serializeAws_restJson1_1UpdateVoiceTemplateCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                headers = {
                    "Content-Type": "application/json"
                };
                resolvedPath = "/v1/templates/{TemplateName}/voice";
                if (input.TemplateName !== undefined) {
                    labelValue = input.TemplateName;
                    if (labelValue.length <= 0) {
                        throw new Error("Empty value provided for input HTTP label: TemplateName.");
                    }
                    resolvedPath = resolvedPath.replace("{TemplateName}", __extendedEncodeURIComponent(labelValue));
                }
                else {
                    throw new Error("No value provided for input HTTP label: TemplateName.");
                }
                query = __assign(__assign({}, (input.CreateNewVersion !== undefined && {
                    "create-new-version": input.CreateNewVersion.toString()
                })), (input.Version !== undefined && { version: input.Version }));
                if (input.VoiceTemplateRequest !== undefined) {
                    body = serializeAws_restJson1_1VoiceTemplateRequest(input.VoiceTemplateRequest, context);
                }
                if (body === undefined) {
                    body = {};
                }
                body = JSON.stringify(body);
                return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                return [2 /*return*/, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "PUT",
                        headers: headers,
                        path: resolvedPath,
                        query: query,
                        body: body
                    })];
        }
    });
}); };
export var deserializeAws_restJson1_1CreateAppCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 201 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1CreateAppCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "CreateAppResponse",
                    ApplicationResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ApplicationResponse = deserializeAws_restJson1_1ApplicationResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1CreateAppCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1CreateCampaignCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 201 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1CreateCampaignCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "CreateCampaignResponse",
                    CampaignResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.CampaignResponse = deserializeAws_restJson1_1CampaignResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1CreateCampaignCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1CreateEmailTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 201 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1CreateEmailTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "CreateEmailTemplateResponse",
                    CreateTemplateMessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.CreateTemplateMessageBody = deserializeAws_restJson1_1CreateTemplateMessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1CreateEmailTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, parsedBody, message;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _j.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1CreateExportJobCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1CreateExportJobCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "CreateExportJobResponse",
                    ExportJobResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ExportJobResponse = deserializeAws_restJson1_1ExportJobResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1CreateExportJobCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1CreateImportJobCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 201 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1CreateImportJobCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "CreateImportJobResponse",
                    ImportJobResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ImportJobResponse = deserializeAws_restJson1_1ImportJobResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1CreateImportJobCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1CreateJourneyCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 201 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1CreateJourneyCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "CreateJourneyResponse",
                    JourneyResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.JourneyResponse = deserializeAws_restJson1_1JourneyResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1CreateJourneyCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1CreatePushTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 201 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1CreatePushTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "CreatePushTemplateResponse",
                    CreateTemplateMessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.CreateTemplateMessageBody = deserializeAws_restJson1_1CreateTemplateMessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1CreatePushTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, parsedBody, message;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _j.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1CreateSegmentCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 201 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1CreateSegmentCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "CreateSegmentResponse",
                    SegmentResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.SegmentResponse = deserializeAws_restJson1_1SegmentResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1CreateSegmentCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1CreateSmsTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 201 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1CreateSmsTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "CreateSmsTemplateResponse",
                    CreateTemplateMessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.CreateTemplateMessageBody = deserializeAws_restJson1_1CreateTemplateMessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1CreateSmsTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, parsedBody, message;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _j.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1CreateVoiceTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 201 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1CreateVoiceTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "CreateVoiceTemplateResponse",
                    CreateTemplateMessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.CreateTemplateMessageBody = deserializeAws_restJson1_1CreateTemplateMessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1CreateVoiceTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, parsedBody, message;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _j.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteAdmChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteAdmChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteAdmChannelResponse",
                    ADMChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ADMChannelResponse = deserializeAws_restJson1_1ADMChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteAdmChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteApnsChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteApnsChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteApnsChannelResponse",
                    APNSChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.APNSChannelResponse = deserializeAws_restJson1_1APNSChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteApnsChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteApnsSandboxChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteApnsSandboxChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteApnsSandboxChannelResponse",
                    APNSSandboxChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.APNSSandboxChannelResponse = deserializeAws_restJson1_1APNSSandboxChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteApnsSandboxChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteApnsVoipChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteApnsVoipChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteApnsVoipChannelResponse",
                    APNSVoipChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.APNSVoipChannelResponse = deserializeAws_restJson1_1APNSVoipChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteApnsVoipChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteApnsVoipSandboxChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteApnsVoipSandboxChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteApnsVoipSandboxChannelResponse",
                    APNSVoipSandboxChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.APNSVoipSandboxChannelResponse = deserializeAws_restJson1_1APNSVoipSandboxChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteApnsVoipSandboxChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteAppCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteAppCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteAppResponse",
                    ApplicationResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ApplicationResponse = deserializeAws_restJson1_1ApplicationResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteAppCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteBaiduChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteBaiduChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteBaiduChannelResponse",
                    BaiduChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.BaiduChannelResponse = deserializeAws_restJson1_1BaiduChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteBaiduChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteCampaignCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteCampaignCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteCampaignResponse",
                    CampaignResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.CampaignResponse = deserializeAws_restJson1_1CampaignResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteCampaignCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteEmailChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteEmailChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteEmailChannelResponse",
                    EmailChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.EmailChannelResponse = deserializeAws_restJson1_1EmailChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteEmailChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteEmailTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteEmailTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteEmailTemplateResponse",
                    MessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.MessageBody = deserializeAws_restJson1_1MessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteEmailTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteEndpointCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteEndpointCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteEndpointResponse",
                    EndpointResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.EndpointResponse = deserializeAws_restJson1_1EndpointResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteEndpointCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteEventStreamCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteEventStreamCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteEventStreamResponse",
                    EventStream: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.EventStream = deserializeAws_restJson1_1EventStream(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteEventStreamCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteGcmChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteGcmChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteGcmChannelResponse",
                    GCMChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.GCMChannelResponse = deserializeAws_restJson1_1GCMChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteGcmChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteJourneyCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteJourneyCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteJourneyResponse",
                    JourneyResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.JourneyResponse = deserializeAws_restJson1_1JourneyResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteJourneyCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeletePushTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeletePushTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeletePushTemplateResponse",
                    MessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.MessageBody = deserializeAws_restJson1_1MessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeletePushTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteSegmentCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteSegmentCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteSegmentResponse",
                    SegmentResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.SegmentResponse = deserializeAws_restJson1_1SegmentResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteSegmentCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteSmsChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteSmsChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteSmsChannelResponse",
                    SMSChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.SMSChannelResponse = deserializeAws_restJson1_1SMSChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteSmsChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteSmsTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteSmsTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteSmsTemplateResponse",
                    MessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.MessageBody = deserializeAws_restJson1_1MessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteSmsTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteUserEndpointsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteUserEndpointsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteUserEndpointsResponse",
                    EndpointsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.EndpointsResponse = deserializeAws_restJson1_1EndpointsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteUserEndpointsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteVoiceChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteVoiceChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteVoiceChannelResponse",
                    VoiceChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.VoiceChannelResponse = deserializeAws_restJson1_1VoiceChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteVoiceChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1DeleteVoiceTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1DeleteVoiceTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "DeleteVoiceTemplateResponse",
                    MessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.MessageBody = deserializeAws_restJson1_1MessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1DeleteVoiceTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetAdmChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetAdmChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetAdmChannelResponse",
                    ADMChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ADMChannelResponse = deserializeAws_restJson1_1ADMChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetAdmChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetApnsChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetApnsChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetApnsChannelResponse",
                    APNSChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.APNSChannelResponse = deserializeAws_restJson1_1APNSChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetApnsChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetApnsSandboxChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetApnsSandboxChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetApnsSandboxChannelResponse",
                    APNSSandboxChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.APNSSandboxChannelResponse = deserializeAws_restJson1_1APNSSandboxChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetApnsSandboxChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetApnsVoipChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetApnsVoipChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetApnsVoipChannelResponse",
                    APNSVoipChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.APNSVoipChannelResponse = deserializeAws_restJson1_1APNSVoipChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetApnsVoipChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetApnsVoipSandboxChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetApnsVoipSandboxChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetApnsVoipSandboxChannelResponse",
                    APNSVoipSandboxChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.APNSVoipSandboxChannelResponse = deserializeAws_restJson1_1APNSVoipSandboxChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetApnsVoipSandboxChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetAppCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetAppCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetAppResponse",
                    ApplicationResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ApplicationResponse = deserializeAws_restJson1_1ApplicationResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetAppCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetApplicationDateRangeKpiCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetApplicationDateRangeKpiCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetApplicationDateRangeKpiResponse",
                    ApplicationDateRangeKpiResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ApplicationDateRangeKpiResponse = deserializeAws_restJson1_1ApplicationDateRangeKpiResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetApplicationDateRangeKpiCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetApplicationSettingsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetApplicationSettingsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetApplicationSettingsResponse",
                    ApplicationSettingsResource: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ApplicationSettingsResource = deserializeAws_restJson1_1ApplicationSettingsResource(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetApplicationSettingsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetAppsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetAppsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetAppsResponse",
                    ApplicationsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ApplicationsResponse = deserializeAws_restJson1_1ApplicationsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetAppsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetBaiduChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetBaiduChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetBaiduChannelResponse",
                    BaiduChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.BaiduChannelResponse = deserializeAws_restJson1_1BaiduChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetBaiduChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetCampaignCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetCampaignCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetCampaignResponse",
                    CampaignResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.CampaignResponse = deserializeAws_restJson1_1CampaignResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetCampaignCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetCampaignActivitiesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetCampaignActivitiesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetCampaignActivitiesResponse",
                    ActivitiesResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ActivitiesResponse = deserializeAws_restJson1_1ActivitiesResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetCampaignActivitiesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetCampaignDateRangeKpiCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetCampaignDateRangeKpiCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetCampaignDateRangeKpiResponse",
                    CampaignDateRangeKpiResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.CampaignDateRangeKpiResponse = deserializeAws_restJson1_1CampaignDateRangeKpiResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetCampaignDateRangeKpiCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetCampaignVersionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetCampaignVersionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetCampaignVersionResponse",
                    CampaignResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.CampaignResponse = deserializeAws_restJson1_1CampaignResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetCampaignVersionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetCampaignVersionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetCampaignVersionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetCampaignVersionsResponse",
                    CampaignsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.CampaignsResponse = deserializeAws_restJson1_1CampaignsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetCampaignVersionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetCampaignsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetCampaignsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetCampaignsResponse",
                    CampaignsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.CampaignsResponse = deserializeAws_restJson1_1CampaignsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetCampaignsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetChannelsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetChannelsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetChannelsResponse",
                    ChannelsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ChannelsResponse = deserializeAws_restJson1_1ChannelsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetChannelsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetEmailChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetEmailChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetEmailChannelResponse",
                    EmailChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.EmailChannelResponse = deserializeAws_restJson1_1EmailChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetEmailChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetEmailTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetEmailTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetEmailTemplateResponse",
                    EmailTemplateResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.EmailTemplateResponse = deserializeAws_restJson1_1EmailTemplateResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetEmailTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetEndpointCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetEndpointCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetEndpointResponse",
                    EndpointResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.EndpointResponse = deserializeAws_restJson1_1EndpointResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetEndpointCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetEventStreamCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetEventStreamCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetEventStreamResponse",
                    EventStream: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.EventStream = deserializeAws_restJson1_1EventStream(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetEventStreamCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetExportJobCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetExportJobCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetExportJobResponse",
                    ExportJobResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ExportJobResponse = deserializeAws_restJson1_1ExportJobResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetExportJobCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetExportJobsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetExportJobsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetExportJobsResponse",
                    ExportJobsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ExportJobsResponse = deserializeAws_restJson1_1ExportJobsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetExportJobsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetGcmChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetGcmChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetGcmChannelResponse",
                    GCMChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.GCMChannelResponse = deserializeAws_restJson1_1GCMChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetGcmChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetImportJobCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetImportJobCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetImportJobResponse",
                    ImportJobResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ImportJobResponse = deserializeAws_restJson1_1ImportJobResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetImportJobCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetImportJobsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetImportJobsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetImportJobsResponse",
                    ImportJobsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ImportJobsResponse = deserializeAws_restJson1_1ImportJobsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetImportJobsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetJourneyCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetJourneyCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetJourneyResponse",
                    JourneyResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.JourneyResponse = deserializeAws_restJson1_1JourneyResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetJourneyCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetJourneyDateRangeKpiCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetJourneyDateRangeKpiCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetJourneyDateRangeKpiResponse",
                    JourneyDateRangeKpiResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.JourneyDateRangeKpiResponse = deserializeAws_restJson1_1JourneyDateRangeKpiResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetJourneyDateRangeKpiCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetJourneyExecutionActivityMetricsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetJourneyExecutionActivityMetricsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetJourneyExecutionActivityMetricsResponse",
                    JourneyExecutionActivityMetricsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.JourneyExecutionActivityMetricsResponse = deserializeAws_restJson1_1JourneyExecutionActivityMetricsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetJourneyExecutionActivityMetricsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetJourneyExecutionMetricsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetJourneyExecutionMetricsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetJourneyExecutionMetricsResponse",
                    JourneyExecutionMetricsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.JourneyExecutionMetricsResponse = deserializeAws_restJson1_1JourneyExecutionMetricsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetJourneyExecutionMetricsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetPushTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetPushTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetPushTemplateResponse",
                    PushNotificationTemplateResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.PushNotificationTemplateResponse = deserializeAws_restJson1_1PushNotificationTemplateResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetPushTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetSegmentCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetSegmentCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetSegmentResponse",
                    SegmentResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.SegmentResponse = deserializeAws_restJson1_1SegmentResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetSegmentCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetSegmentExportJobsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetSegmentExportJobsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetSegmentExportJobsResponse",
                    ExportJobsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ExportJobsResponse = deserializeAws_restJson1_1ExportJobsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetSegmentExportJobsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetSegmentImportJobsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetSegmentImportJobsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetSegmentImportJobsResponse",
                    ImportJobsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ImportJobsResponse = deserializeAws_restJson1_1ImportJobsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetSegmentImportJobsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetSegmentVersionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetSegmentVersionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetSegmentVersionResponse",
                    SegmentResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.SegmentResponse = deserializeAws_restJson1_1SegmentResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetSegmentVersionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetSegmentVersionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetSegmentVersionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetSegmentVersionsResponse",
                    SegmentsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.SegmentsResponse = deserializeAws_restJson1_1SegmentsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetSegmentVersionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetSegmentsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetSegmentsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetSegmentsResponse",
                    SegmentsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.SegmentsResponse = deserializeAws_restJson1_1SegmentsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetSegmentsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetSmsChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetSmsChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetSmsChannelResponse",
                    SMSChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.SMSChannelResponse = deserializeAws_restJson1_1SMSChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetSmsChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetSmsTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetSmsTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetSmsTemplateResponse",
                    SMSTemplateResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.SMSTemplateResponse = deserializeAws_restJson1_1SMSTemplateResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetSmsTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetUserEndpointsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetUserEndpointsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetUserEndpointsResponse",
                    EndpointsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.EndpointsResponse = deserializeAws_restJson1_1EndpointsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetUserEndpointsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetVoiceChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetVoiceChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetVoiceChannelResponse",
                    VoiceChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.VoiceChannelResponse = deserializeAws_restJson1_1VoiceChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetVoiceChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1GetVoiceTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1GetVoiceTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "GetVoiceTemplateResponse",
                    VoiceTemplateResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.VoiceTemplateResponse = deserializeAws_restJson1_1VoiceTemplateResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1GetVoiceTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1ListJourneysCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1ListJourneysCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "ListJourneysResponse",
                    JourneysResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.JourneysResponse = deserializeAws_restJson1_1JourneysResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1ListJourneysCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1ListTagsForResourceCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1ListTagsForResourceCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "ListTagsForResourceResponse",
                    TagsModel: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.TagsModel = deserializeAws_restJson1_1TagsModel(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1ListTagsForResourceCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, parsedBody, message;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                switch (errorCode) {
                    default:
                        parsedBody = parsedOutput.body;
                        errorCode = parsedBody.code || parsedBody.Code || errorCode;
                        response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                }
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1ListTemplateVersionsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1ListTemplateVersionsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "ListTemplateVersionsResponse",
                    TemplateVersionsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.TemplateVersionsResponse = deserializeAws_restJson1_1TemplateVersionsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1ListTemplateVersionsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1ListTemplatesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1ListTemplatesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "ListTemplatesResponse",
                    TemplatesResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.TemplatesResponse = deserializeAws_restJson1_1TemplatesResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1ListTemplatesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, parsedBody, message;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _j.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1PhoneNumberValidateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1PhoneNumberValidateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "PhoneNumberValidateResponse",
                    NumberValidateResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.NumberValidateResponse = deserializeAws_restJson1_1NumberValidateResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1PhoneNumberValidateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1PutEventStreamCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1PutEventStreamCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "PutEventStreamResponse",
                    EventStream: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.EventStream = deserializeAws_restJson1_1EventStream(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1PutEventStreamCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1PutEventsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1PutEventsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "PutEventsResponse",
                    EventsResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.EventsResponse = deserializeAws_restJson1_1EventsResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1PutEventsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1RemoveAttributesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1RemoveAttributesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "RemoveAttributesResponse",
                    AttributesResource: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.AttributesResource = deserializeAws_restJson1_1AttributesResource(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1RemoveAttributesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1SendMessagesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1SendMessagesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "SendMessagesResponse",
                    MessageResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.MessageResponse = deserializeAws_restJson1_1MessageResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1SendMessagesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1SendUsersMessagesCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1SendUsersMessagesCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "SendUsersMessagesResponse",
                    SendUsersMessageResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.SendUsersMessageResponse = deserializeAws_restJson1_1SendUsersMessageResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1SendUsersMessagesCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1TagResourceCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 204 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1TagResourceCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output)
                };
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1TagResourceCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, parsedBody, message;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                switch (errorCode) {
                    default:
                        parsedBody = parsedOutput.body;
                        errorCode = parsedBody.code || parsedBody.Code || errorCode;
                        response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                }
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UntagResourceCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 204 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UntagResourceCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output)
                };
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UntagResourceCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, parsedBody, message;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                switch (errorCode) {
                    default:
                        parsedBody = parsedOutput.body;
                        errorCode = parsedBody.code || parsedBody.Code || errorCode;
                        response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                }
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateAdmChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateAdmChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateAdmChannelResponse",
                    ADMChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ADMChannelResponse = deserializeAws_restJson1_1ADMChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateAdmChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateApnsChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateApnsChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateApnsChannelResponse",
                    APNSChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.APNSChannelResponse = deserializeAws_restJson1_1APNSChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateApnsChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateApnsSandboxChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateApnsSandboxChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateApnsSandboxChannelResponse",
                    APNSSandboxChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.APNSSandboxChannelResponse = deserializeAws_restJson1_1APNSSandboxChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateApnsSandboxChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateApnsVoipChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateApnsVoipChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateApnsVoipChannelResponse",
                    APNSVoipChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.APNSVoipChannelResponse = deserializeAws_restJson1_1APNSVoipChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateApnsVoipChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateApnsVoipSandboxChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateApnsVoipSandboxChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateApnsVoipSandboxChannelResponse",
                    APNSVoipSandboxChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.APNSVoipSandboxChannelResponse = deserializeAws_restJson1_1APNSVoipSandboxChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateApnsVoipSandboxChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateApplicationSettingsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateApplicationSettingsCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateApplicationSettingsResponse",
                    ApplicationSettingsResource: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.ApplicationSettingsResource = deserializeAws_restJson1_1ApplicationSettingsResource(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateApplicationSettingsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateBaiduChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateBaiduChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateBaiduChannelResponse",
                    BaiduChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.BaiduChannelResponse = deserializeAws_restJson1_1BaiduChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateBaiduChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateCampaignCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateCampaignCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateCampaignResponse",
                    CampaignResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.CampaignResponse = deserializeAws_restJson1_1CampaignResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateCampaignCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateEmailChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateEmailChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateEmailChannelResponse",
                    EmailChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.EmailChannelResponse = deserializeAws_restJson1_1EmailChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateEmailChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateEmailTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateEmailTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateEmailTemplateResponse",
                    MessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.MessageBody = deserializeAws_restJson1_1MessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateEmailTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateEndpointCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateEndpointCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateEndpointResponse",
                    MessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.MessageBody = deserializeAws_restJson1_1MessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateEndpointCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateEndpointsBatchCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateEndpointsBatchCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateEndpointsBatchResponse",
                    MessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.MessageBody = deserializeAws_restJson1_1MessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateEndpointsBatchCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateGcmChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateGcmChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateGcmChannelResponse",
                    GCMChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.GCMChannelResponse = deserializeAws_restJson1_1GCMChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateGcmChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateJourneyCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateJourneyCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateJourneyResponse",
                    JourneyResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.JourneyResponse = deserializeAws_restJson1_1JourneyResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateJourneyCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateJourneyStateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateJourneyStateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateJourneyStateResponse",
                    JourneyResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.JourneyResponse = deserializeAws_restJson1_1JourneyResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateJourneyStateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdatePushTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdatePushTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdatePushTemplateResponse",
                    MessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.MessageBody = deserializeAws_restJson1_1MessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdatePushTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateSegmentCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateSegmentCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateSegmentResponse",
                    SegmentResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.SegmentResponse = deserializeAws_restJson1_1SegmentResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateSegmentCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateSmsChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateSmsChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateSmsChannelResponse",
                    SMSChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.SMSChannelResponse = deserializeAws_restJson1_1SMSChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateSmsChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateSmsTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateSmsTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateSmsTemplateResponse",
                    MessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.MessageBody = deserializeAws_restJson1_1MessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateSmsTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateTemplateActiveVersionCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateTemplateActiveVersionCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateTemplateActiveVersionResponse",
                    MessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.MessageBody = deserializeAws_restJson1_1MessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateTemplateActiveVersionCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateVoiceChannelCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateVoiceChannelCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateVoiceChannelResponse",
                    VoiceChannelResponse: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.VoiceChannelResponse = deserializeAws_restJson1_1VoiceChannelResponse(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateVoiceChannelCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
export var deserializeAws_restJson1_1UpdateVoiceTemplateCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 202 && output.statusCode >= 400) {
                    return [2 /*return*/, deserializeAws_restJson1_1UpdateVoiceTemplateCommandError(output, context)];
                }
                contents = {
                    $metadata: deserializeMetadata(output),
                    __type: "UpdateVoiceTemplateResponse",
                    MessageBody: undefined
                };
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents.MessageBody = deserializeAws_restJson1_1MessageBody(data, context);
                return [2 /*return*/, Promise.resolve(contents)];
        }
    });
}); };
var deserializeAws_restJson1_1UpdateVoiceTemplateCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, _b, response, errorCode, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__assign({}, output)];
                _b = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _k.sent(), _b)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _c = errorCode;
                switch (_c) {
                    case "BadRequestException": return [3 /*break*/, 2];
                    case "com.amazonaws.pinpoint#BadRequestException": return [3 /*break*/, 2];
                    case "ForbiddenException": return [3 /*break*/, 4];
                    case "com.amazonaws.pinpoint#ForbiddenException": return [3 /*break*/, 4];
                    case "InternalServerErrorException": return [3 /*break*/, 6];
                    case "com.amazonaws.pinpoint#InternalServerErrorException": return [3 /*break*/, 6];
                    case "MethodNotAllowedException": return [3 /*break*/, 8];
                    case "com.amazonaws.pinpoint#MethodNotAllowedException": return [3 /*break*/, 8];
                    case "NotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.pinpoint#NotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.pinpoint#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1BadRequestExceptionResponse(parsedOutput, context)];
            case 3:
                response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1ForbiddenExceptionResponse(parsedOutput, context)];
            case 5:
                response = __assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1InternalServerErrorExceptionResponse(parsedOutput, context)];
            case 7:
                response = __assign.apply(void 0, [__assign.apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1MethodNotAllowedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __assign.apply(void 0, [__assign.apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1NotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __assign.apply(void 0, [__assign.apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_restJson1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __assign(__assign({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_restJson1_1BadRequestExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        contents = {
            name: "BadRequestException",
            $fault: "client",
            $metadata: deserializeMetadata(parsedOutput),
            Message: undefined,
            RequestID: undefined
        };
        data = parsedOutput.body;
        if (data.Message !== undefined && data.Message !== null) {
            contents.Message = data.Message;
        }
        if (data.RequestID !== undefined && data.RequestID !== null) {
            contents.RequestID = data.RequestID;
        }
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_restJson1_1ForbiddenExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        contents = {
            name: "ForbiddenException",
            $fault: "client",
            $metadata: deserializeMetadata(parsedOutput),
            Message: undefined,
            RequestID: undefined
        };
        data = parsedOutput.body;
        if (data.Message !== undefined && data.Message !== null) {
            contents.Message = data.Message;
        }
        if (data.RequestID !== undefined && data.RequestID !== null) {
            contents.RequestID = data.RequestID;
        }
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_restJson1_1InternalServerErrorExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        contents = {
            name: "InternalServerErrorException",
            $fault: "server",
            $metadata: deserializeMetadata(parsedOutput),
            Message: undefined,
            RequestID: undefined
        };
        data = parsedOutput.body;
        if (data.Message !== undefined && data.Message !== null) {
            contents.Message = data.Message;
        }
        if (data.RequestID !== undefined && data.RequestID !== null) {
            contents.RequestID = data.RequestID;
        }
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_restJson1_1MethodNotAllowedExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        contents = {
            name: "MethodNotAllowedException",
            $fault: "client",
            $metadata: deserializeMetadata(parsedOutput),
            Message: undefined,
            RequestID: undefined
        };
        data = parsedOutput.body;
        if (data.Message !== undefined && data.Message !== null) {
            contents.Message = data.Message;
        }
        if (data.RequestID !== undefined && data.RequestID !== null) {
            contents.RequestID = data.RequestID;
        }
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_restJson1_1NotFoundExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        contents = {
            name: "NotFoundException",
            $fault: "client",
            $metadata: deserializeMetadata(parsedOutput),
            Message: undefined,
            RequestID: undefined
        };
        data = parsedOutput.body;
        if (data.Message !== undefined && data.Message !== null) {
            contents.Message = data.Message;
        }
        if (data.RequestID !== undefined && data.RequestID !== null) {
            contents.RequestID = data.RequestID;
        }
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_restJson1_1TooManyRequestsExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
        contents = {
            name: "TooManyRequestsException",
            $fault: "client",
            $metadata: deserializeMetadata(parsedOutput),
            Message: undefined,
            RequestID: undefined
        };
        data = parsedOutput.body;
        if (data.Message !== undefined && data.Message !== null) {
            contents.Message = data.Message;
        }
        if (data.RequestID !== undefined && data.RequestID !== null) {
            contents.RequestID = data.RequestID;
        }
        return [2 /*return*/, contents];
    });
}); };
var serializeAws_restJson1_1ADMChannelRequest = function (input, context) {
    return __assign(__assign(__assign({}, (input.ClientId !== undefined && { ClientId: input.ClientId })), (input.ClientSecret !== undefined && {
        ClientSecret: input.ClientSecret
    })), (input.Enabled !== undefined && { Enabled: input.Enabled }));
};
var serializeAws_restJson1_1ADMMessage = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.Action !== undefined && { Action: input.Action })), (input.Body !== undefined && { Body: input.Body })), (input.ConsolidationKey !== undefined && {
        ConsolidationKey: input.ConsolidationKey
    })), (input.Data !== undefined && {
        Data: serializeAws_restJson1_1MapOf__string(input.Data, context)
    })), (input.ExpiresAfter !== undefined && {
        ExpiresAfter: input.ExpiresAfter
    })), (input.IconReference !== undefined && {
        IconReference: input.IconReference
    })), (input.ImageIconUrl !== undefined && {
        ImageIconUrl: input.ImageIconUrl
    })), (input.ImageUrl !== undefined && { ImageUrl: input.ImageUrl })), (input.MD5 !== undefined && { MD5: input.MD5 })), (input.RawContent !== undefined && { RawContent: input.RawContent })), (input.SilentPush !== undefined && { SilentPush: input.SilentPush })), (input.SmallImageIconUrl !== undefined && {
        SmallImageIconUrl: input.SmallImageIconUrl
    })), (input.Sound !== undefined && { Sound: input.Sound })), (input.Substitutions !== undefined && {
        Substitutions: serializeAws_restJson1_1MapOfListOf__string(input.Substitutions, context)
    })), (input.Title !== undefined && { Title: input.Title })), (input.Url !== undefined && { Url: input.Url }));
};
var serializeAws_restJson1_1APNSChannelRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.BundleId !== undefined && { BundleId: input.BundleId })), (input.Certificate !== undefined && { Certificate: input.Certificate })), (input.DefaultAuthenticationMethod !== undefined && {
        DefaultAuthenticationMethod: input.DefaultAuthenticationMethod
    })), (input.Enabled !== undefined && { Enabled: input.Enabled })), (input.PrivateKey !== undefined && { PrivateKey: input.PrivateKey })), (input.TeamId !== undefined && { TeamId: input.TeamId })), (input.TokenKey !== undefined && { TokenKey: input.TokenKey })), (input.TokenKeyId !== undefined && { TokenKeyId: input.TokenKeyId }));
};
var serializeAws_restJson1_1APNSMessage = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.APNSPushType !== undefined && {
        APNSPushType: input.APNSPushType
    })), (input.Action !== undefined && { Action: input.Action })), (input.Badge !== undefined && { Badge: input.Badge })), (input.Body !== undefined && { Body: input.Body })), (input.Category !== undefined && { Category: input.Category })), (input.CollapseId !== undefined && { CollapseId: input.CollapseId })), (input.Data !== undefined && {
        Data: serializeAws_restJson1_1MapOf__string(input.Data, context)
    })), (input.MediaUrl !== undefined && { MediaUrl: input.MediaUrl })), (input.PreferredAuthenticationMethod !== undefined && {
        PreferredAuthenticationMethod: input.PreferredAuthenticationMethod
    })), (input.Priority !== undefined && { Priority: input.Priority })), (input.RawContent !== undefined && { RawContent: input.RawContent })), (input.SilentPush !== undefined && { SilentPush: input.SilentPush })), (input.Sound !== undefined && { Sound: input.Sound })), (input.Substitutions !== undefined && {
        Substitutions: serializeAws_restJson1_1MapOfListOf__string(input.Substitutions, context)
    })), (input.ThreadId !== undefined && { ThreadId: input.ThreadId })), (input.TimeToLive !== undefined && { TimeToLive: input.TimeToLive })), (input.Title !== undefined && { Title: input.Title })), (input.Url !== undefined && { Url: input.Url }));
};
var serializeAws_restJson1_1APNSPushNotificationTemplate = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.Action !== undefined && { Action: input.Action })), (input.Body !== undefined && { Body: input.Body })), (input.MediaUrl !== undefined && { MediaUrl: input.MediaUrl })), (input.RawContent !== undefined && { RawContent: input.RawContent })), (input.Sound !== undefined && { Sound: input.Sound })), (input.Title !== undefined && { Title: input.Title })), (input.Url !== undefined && { Url: input.Url }));
};
var serializeAws_restJson1_1APNSSandboxChannelRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.BundleId !== undefined && { BundleId: input.BundleId })), (input.Certificate !== undefined && { Certificate: input.Certificate })), (input.DefaultAuthenticationMethod !== undefined && {
        DefaultAuthenticationMethod: input.DefaultAuthenticationMethod
    })), (input.Enabled !== undefined && { Enabled: input.Enabled })), (input.PrivateKey !== undefined && { PrivateKey: input.PrivateKey })), (input.TeamId !== undefined && { TeamId: input.TeamId })), (input.TokenKey !== undefined && { TokenKey: input.TokenKey })), (input.TokenKeyId !== undefined && { TokenKeyId: input.TokenKeyId }));
};
var serializeAws_restJson1_1APNSVoipChannelRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.BundleId !== undefined && { BundleId: input.BundleId })), (input.Certificate !== undefined && { Certificate: input.Certificate })), (input.DefaultAuthenticationMethod !== undefined && {
        DefaultAuthenticationMethod: input.DefaultAuthenticationMethod
    })), (input.Enabled !== undefined && { Enabled: input.Enabled })), (input.PrivateKey !== undefined && { PrivateKey: input.PrivateKey })), (input.TeamId !== undefined && { TeamId: input.TeamId })), (input.TokenKey !== undefined && { TokenKey: input.TokenKey })), (input.TokenKeyId !== undefined && { TokenKeyId: input.TokenKeyId }));
};
var serializeAws_restJson1_1APNSVoipSandboxChannelRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.BundleId !== undefined && { BundleId: input.BundleId })), (input.Certificate !== undefined && { Certificate: input.Certificate })), (input.DefaultAuthenticationMethod !== undefined && {
        DefaultAuthenticationMethod: input.DefaultAuthenticationMethod
    })), (input.Enabled !== undefined && { Enabled: input.Enabled })), (input.PrivateKey !== undefined && { PrivateKey: input.PrivateKey })), (input.TeamId !== undefined && { TeamId: input.TeamId })), (input.TokenKey !== undefined && { TokenKey: input.TokenKey })), (input.TokenKeyId !== undefined && { TokenKeyId: input.TokenKeyId }));
};
var serializeAws_restJson1_1Activity = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.ConditionalSplit !== undefined && {
        ConditionalSplit: serializeAws_restJson1_1ConditionalSplitActivity(input.ConditionalSplit, context)
    })), (input.Description !== undefined && { Description: input.Description })), (input.EMAIL !== undefined && {
        EMAIL: serializeAws_restJson1_1EmailMessageActivity(input.EMAIL, context)
    })), (input.Holdout !== undefined && {
        Holdout: serializeAws_restJson1_1HoldoutActivity(input.Holdout, context)
    })), (input.MultiCondition !== undefined && {
        MultiCondition: serializeAws_restJson1_1MultiConditionalSplitActivity(input.MultiCondition, context)
    })), (input.RandomSplit !== undefined && {
        RandomSplit: serializeAws_restJson1_1RandomSplitActivity(input.RandomSplit, context)
    })), (input.Wait !== undefined && {
        Wait: serializeAws_restJson1_1WaitActivity(input.Wait, context)
    }));
};
var serializeAws_restJson1_1AddressConfiguration = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.BodyOverride !== undefined && {
        BodyOverride: input.BodyOverride
    })), (input.ChannelType !== undefined && { ChannelType: input.ChannelType })), (input.Context !== undefined && {
        Context: serializeAws_restJson1_1MapOf__string(input.Context, context)
    })), (input.RawContent !== undefined && { RawContent: input.RawContent })), (input.Substitutions !== undefined && {
        Substitutions: serializeAws_restJson1_1MapOfListOf__string(input.Substitutions, context)
    })), (input.TitleOverride !== undefined && {
        TitleOverride: input.TitleOverride
    }));
};
var serializeAws_restJson1_1AndroidPushNotificationTemplate = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.Action !== undefined && { Action: input.Action })), (input.Body !== undefined && { Body: input.Body })), (input.ImageIconUrl !== undefined && {
        ImageIconUrl: input.ImageIconUrl
    })), (input.ImageUrl !== undefined && { ImageUrl: input.ImageUrl })), (input.RawContent !== undefined && { RawContent: input.RawContent })), (input.SmallImageIconUrl !== undefined && {
        SmallImageIconUrl: input.SmallImageIconUrl
    })), (input.Sound !== undefined && { Sound: input.Sound })), (input.Title !== undefined && { Title: input.Title })), (input.Url !== undefined && { Url: input.Url }));
};
var serializeAws_restJson1_1AttributeDimension = function (input, context) {
    return __assign(__assign({}, (input.AttributeType !== undefined && {
        AttributeType: input.AttributeType
    })), (input.Values !== undefined && {
        Values: serializeAws_restJson1_1ListOf__string(input.Values, context)
    }));
};
var serializeAws_restJson1_1BaiduChannelRequest = function (input, context) {
    return __assign(__assign(__assign({}, (input.ApiKey !== undefined && { ApiKey: input.ApiKey })), (input.Enabled !== undefined && { Enabled: input.Enabled })), (input.SecretKey !== undefined && { SecretKey: input.SecretKey }));
};
var serializeAws_restJson1_1BaiduMessage = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.Action !== undefined && { Action: input.Action })), (input.Body !== undefined && { Body: input.Body })), (input.Data !== undefined && {
        Data: serializeAws_restJson1_1MapOf__string(input.Data, context)
    })), (input.IconReference !== undefined && {
        IconReference: input.IconReference
    })), (input.ImageIconUrl !== undefined && {
        ImageIconUrl: input.ImageIconUrl
    })), (input.ImageUrl !== undefined && { ImageUrl: input.ImageUrl })), (input.RawContent !== undefined && { RawContent: input.RawContent })), (input.SilentPush !== undefined && { SilentPush: input.SilentPush })), (input.SmallImageIconUrl !== undefined && {
        SmallImageIconUrl: input.SmallImageIconUrl
    })), (input.Sound !== undefined && { Sound: input.Sound })), (input.Substitutions !== undefined && {
        Substitutions: serializeAws_restJson1_1MapOfListOf__string(input.Substitutions, context)
    })), (input.TimeToLive !== undefined && { TimeToLive: input.TimeToLive })), (input.Title !== undefined && { Title: input.Title })), (input.Url !== undefined && { Url: input.Url }));
};
var serializeAws_restJson1_1CampaignEmailMessage = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.Body !== undefined && { Body: input.Body })), (input.FromAddress !== undefined && { FromAddress: input.FromAddress })), (input.HtmlBody !== undefined && { HtmlBody: input.HtmlBody })), (input.Title !== undefined && { Title: input.Title }));
};
var serializeAws_restJson1_1CampaignEventFilter = function (input, context) {
    return __assign(__assign({}, (input.Dimensions !== undefined && {
        Dimensions: serializeAws_restJson1_1EventDimensions(input.Dimensions, context)
    })), (input.FilterType !== undefined && { FilterType: input.FilterType }));
};
var serializeAws_restJson1_1CampaignHook = function (input, context) {
    return __assign(__assign(__assign({}, (input.LambdaFunctionName !== undefined && {
        LambdaFunctionName: input.LambdaFunctionName
    })), (input.Mode !== undefined && { Mode: input.Mode })), (input.WebUrl !== undefined && { WebUrl: input.WebUrl }));
};
var serializeAws_restJson1_1CampaignLimits = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.Daily !== undefined && { Daily: input.Daily })), (input.MaximumDuration !== undefined && {
        MaximumDuration: input.MaximumDuration
    })), (input.MessagesPerSecond !== undefined && {
        MessagesPerSecond: input.MessagesPerSecond
    })), (input.Total !== undefined && { Total: input.Total }));
};
var serializeAws_restJson1_1CampaignSmsMessage = function (input, context) {
    return __assign(__assign(__assign({}, (input.Body !== undefined && { Body: input.Body })), (input.MessageType !== undefined && { MessageType: input.MessageType })), (input.SenderId !== undefined && { SenderId: input.SenderId }));
};
var serializeAws_restJson1_1Condition = function (input, context) {
    return __assign(__assign({}, (input.Conditions !== undefined && {
        Conditions: serializeAws_restJson1_1ListOfSimpleCondition(input.Conditions, context)
    })), (input.Operator !== undefined && { Operator: input.Operator }));
};
var serializeAws_restJson1_1ConditionalSplitActivity = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.Condition !== undefined && {
        Condition: serializeAws_restJson1_1Condition(input.Condition, context)
    })), (input.EvaluationWaitTime !== undefined && {
        EvaluationWaitTime: serializeAws_restJson1_1WaitTime(input.EvaluationWaitTime, context)
    })), (input.FalseActivity !== undefined && {
        FalseActivity: input.FalseActivity
    })), (input.TrueActivity !== undefined && {
        TrueActivity: input.TrueActivity
    }));
};
var serializeAws_restJson1_1CreateApplicationRequest = function (input, context) {
    return __assign(__assign({}, (input.Name !== undefined && { Name: input.Name })), (input.tags !== undefined && {
        tags: serializeAws_restJson1_1MapOf__string(input.tags, context)
    }));
};
var serializeAws_restJson1_1DefaultMessage = function (input, context) {
    return __assign(__assign({}, (input.Body !== undefined && { Body: input.Body })), (input.Substitutions !== undefined && {
        Substitutions: serializeAws_restJson1_1MapOfListOf__string(input.Substitutions, context)
    }));
};
var serializeAws_restJson1_1DefaultPushNotificationMessage = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.Action !== undefined && { Action: input.Action })), (input.Body !== undefined && { Body: input.Body })), (input.Data !== undefined && {
        Data: serializeAws_restJson1_1MapOf__string(input.Data, context)
    })), (input.SilentPush !== undefined && { SilentPush: input.SilentPush })), (input.Substitutions !== undefined && {
        Substitutions: serializeAws_restJson1_1MapOfListOf__string(input.Substitutions, context)
    })), (input.Title !== undefined && { Title: input.Title })), (input.Url !== undefined && { Url: input.Url }));
};
var serializeAws_restJson1_1DefaultPushNotificationTemplate = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign({}, (input.Action !== undefined && { Action: input.Action })), (input.Body !== undefined && { Body: input.Body })), (input.Sound !== undefined && { Sound: input.Sound })), (input.Title !== undefined && { Title: input.Title })), (input.Url !== undefined && { Url: input.Url }));
};
var serializeAws_restJson1_1DirectMessageConfiguration = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.ADMMessage !== undefined && {
        ADMMessage: serializeAws_restJson1_1ADMMessage(input.ADMMessage, context)
    })), (input.APNSMessage !== undefined && {
        APNSMessage: serializeAws_restJson1_1APNSMessage(input.APNSMessage, context)
    })), (input.BaiduMessage !== undefined && {
        BaiduMessage: serializeAws_restJson1_1BaiduMessage(input.BaiduMessage, context)
    })), (input.DefaultMessage !== undefined && {
        DefaultMessage: serializeAws_restJson1_1DefaultMessage(input.DefaultMessage, context)
    })), (input.DefaultPushNotificationMessage !== undefined && {
        DefaultPushNotificationMessage: serializeAws_restJson1_1DefaultPushNotificationMessage(input.DefaultPushNotificationMessage, context)
    })), (input.EmailMessage !== undefined && {
        EmailMessage: serializeAws_restJson1_1EmailMessage(input.EmailMessage, context)
    })), (input.GCMMessage !== undefined && {
        GCMMessage: serializeAws_restJson1_1GCMMessage(input.GCMMessage, context)
    })), (input.SMSMessage !== undefined && {
        SMSMessage: serializeAws_restJson1_1SMSMessage(input.SMSMessage, context)
    })), (input.VoiceMessage !== undefined && {
        VoiceMessage: serializeAws_restJson1_1VoiceMessage(input.VoiceMessage, context)
    }));
};
var serializeAws_restJson1_1EmailChannelRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign({}, (input.ConfigurationSet !== undefined && {
        ConfigurationSet: input.ConfigurationSet
    })), (input.Enabled !== undefined && { Enabled: input.Enabled })), (input.FromAddress !== undefined && { FromAddress: input.FromAddress })), (input.Identity !== undefined && { Identity: input.Identity })), (input.RoleArn !== undefined && { RoleArn: input.RoleArn }));
};
var serializeAws_restJson1_1EmailMessage = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.Body !== undefined && { Body: input.Body })), (input.FeedbackForwardingAddress !== undefined && {
        FeedbackForwardingAddress: input.FeedbackForwardingAddress
    })), (input.FromAddress !== undefined && { FromAddress: input.FromAddress })), (input.RawEmail !== undefined && {
        RawEmail: serializeAws_restJson1_1RawEmail(input.RawEmail, context)
    })), (input.ReplyToAddresses !== undefined && {
        ReplyToAddresses: serializeAws_restJson1_1ListOf__string(input.ReplyToAddresses, context)
    })), (input.SimpleEmail !== undefined && {
        SimpleEmail: serializeAws_restJson1_1SimpleEmail(input.SimpleEmail, context)
    })), (input.Substitutions !== undefined && {
        Substitutions: serializeAws_restJson1_1MapOfListOf__string(input.Substitutions, context)
    }));
};
var serializeAws_restJson1_1EmailMessageActivity = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.MessageConfig !== undefined && {
        MessageConfig: serializeAws_restJson1_1JourneyEmailMessage(input.MessageConfig, context)
    })), (input.NextActivity !== undefined && {
        NextActivity: input.NextActivity
    })), (input.TemplateName !== undefined && {
        TemplateName: input.TemplateName
    })), (input.TemplateVersion !== undefined && {
        TemplateVersion: input.TemplateVersion
    }));
};
var serializeAws_restJson1_1EmailTemplateRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.DefaultSubstitutions !== undefined && {
        DefaultSubstitutions: input.DefaultSubstitutions
    })), (input.HtmlPart !== undefined && { HtmlPart: input.HtmlPart })), (input.Subject !== undefined && { Subject: input.Subject })), (input.TemplateDescription !== undefined && {
        TemplateDescription: input.TemplateDescription
    })), (input.TextPart !== undefined && { TextPart: input.TextPart })), (input.tags !== undefined && {
        tags: serializeAws_restJson1_1MapOf__string(input.tags, context)
    }));
};
var serializeAws_restJson1_1EndpointBatchItem = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.Address !== undefined && { Address: input.Address })), (input.Attributes !== undefined && {
        Attributes: serializeAws_restJson1_1MapOfListOf__string(input.Attributes, context)
    })), (input.ChannelType !== undefined && { ChannelType: input.ChannelType })), (input.Demographic !== undefined && {
        Demographic: serializeAws_restJson1_1EndpointDemographic(input.Demographic, context)
    })), (input.EffectiveDate !== undefined && {
        EffectiveDate: input.EffectiveDate
    })), (input.EndpointStatus !== undefined && {
        EndpointStatus: input.EndpointStatus
    })), (input.Id !== undefined && { Id: input.Id })), (input.Location !== undefined && {
        Location: serializeAws_restJson1_1EndpointLocation(input.Location, context)
    })), (input.Metrics !== undefined && {
        Metrics: serializeAws_restJson1_1MapOf__double(input.Metrics, context)
    })), (input.OptOut !== undefined && { OptOut: input.OptOut })), (input.RequestId !== undefined && { RequestId: input.RequestId })), (input.User !== undefined && {
        User: serializeAws_restJson1_1EndpointUser(input.User, context)
    }));
};
var serializeAws_restJson1_1EndpointBatchRequest = function (input, context) {
    return __assign({}, (input.Item !== undefined && {
        Item: serializeAws_restJson1_1ListOfEndpointBatchItem(input.Item, context)
    }));
};
var serializeAws_restJson1_1EndpointDemographic = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.AppVersion !== undefined && { AppVersion: input.AppVersion })), (input.Locale !== undefined && { Locale: input.Locale })), (input.Make !== undefined && { Make: input.Make })), (input.Model !== undefined && { Model: input.Model })), (input.ModelVersion !== undefined && {
        ModelVersion: input.ModelVersion
    })), (input.Platform !== undefined && { Platform: input.Platform })), (input.PlatformVersion !== undefined && {
        PlatformVersion: input.PlatformVersion
    })), (input.Timezone !== undefined && { Timezone: input.Timezone }));
};
var serializeAws_restJson1_1EndpointLocation = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.City !== undefined && { City: input.City })), (input.Country !== undefined && { Country: input.Country })), (input.Latitude !== undefined && { Latitude: input.Latitude })), (input.Longitude !== undefined && { Longitude: input.Longitude })), (input.PostalCode !== undefined && { PostalCode: input.PostalCode })), (input.Region !== undefined && { Region: input.Region }));
};
var serializeAws_restJson1_1EndpointRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.Address !== undefined && { Address: input.Address })), (input.Attributes !== undefined && {
        Attributes: serializeAws_restJson1_1MapOfListOf__string(input.Attributes, context)
    })), (input.ChannelType !== undefined && { ChannelType: input.ChannelType })), (input.Demographic !== undefined && {
        Demographic: serializeAws_restJson1_1EndpointDemographic(input.Demographic, context)
    })), (input.EffectiveDate !== undefined && {
        EffectiveDate: input.EffectiveDate
    })), (input.EndpointStatus !== undefined && {
        EndpointStatus: input.EndpointStatus
    })), (input.Location !== undefined && {
        Location: serializeAws_restJson1_1EndpointLocation(input.Location, context)
    })), (input.Metrics !== undefined && {
        Metrics: serializeAws_restJson1_1MapOf__double(input.Metrics, context)
    })), (input.OptOut !== undefined && { OptOut: input.OptOut })), (input.RequestId !== undefined && { RequestId: input.RequestId })), (input.User !== undefined && {
        User: serializeAws_restJson1_1EndpointUser(input.User, context)
    }));
};
var serializeAws_restJson1_1EndpointSendConfiguration = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign({}, (input.BodyOverride !== undefined && {
        BodyOverride: input.BodyOverride
    })), (input.Context !== undefined && {
        Context: serializeAws_restJson1_1MapOf__string(input.Context, context)
    })), (input.RawContent !== undefined && { RawContent: input.RawContent })), (input.Substitutions !== undefined && {
        Substitutions: serializeAws_restJson1_1MapOfListOf__string(input.Substitutions, context)
    })), (input.TitleOverride !== undefined && {
        TitleOverride: input.TitleOverride
    }));
};
var serializeAws_restJson1_1EndpointUser = function (input, context) {
    return __assign(__assign({}, (input.UserAttributes !== undefined && {
        UserAttributes: serializeAws_restJson1_1MapOfListOf__string(input.UserAttributes, context)
    })), (input.UserId !== undefined && { UserId: input.UserId }));
};
var serializeAws_restJson1_1Event = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.AppPackageName !== undefined && {
        AppPackageName: input.AppPackageName
    })), (input.AppTitle !== undefined && { AppTitle: input.AppTitle })), (input.AppVersionCode !== undefined && {
        AppVersionCode: input.AppVersionCode
    })), (input.Attributes !== undefined && {
        Attributes: serializeAws_restJson1_1MapOf__string(input.Attributes, context)
    })), (input.ClientSdkVersion !== undefined && {
        ClientSdkVersion: input.ClientSdkVersion
    })), (input.EventType !== undefined && { EventType: input.EventType })), (input.Metrics !== undefined && {
        Metrics: serializeAws_restJson1_1MapOf__double(input.Metrics, context)
    })), (input.SdkName !== undefined && { SdkName: input.SdkName })), (input.Session !== undefined && {
        Session: serializeAws_restJson1_1Session(input.Session, context)
    })), (input.Timestamp !== undefined && { Timestamp: input.Timestamp }));
};
var serializeAws_restJson1_1EventCondition = function (input, context) {
    return __assign(__assign({}, (input.Dimensions !== undefined && {
        Dimensions: serializeAws_restJson1_1EventDimensions(input.Dimensions, context)
    })), (input.MessageActivity !== undefined && {
        MessageActivity: input.MessageActivity
    }));
};
var serializeAws_restJson1_1EventDimensions = function (input, context) {
    return __assign(__assign(__assign({}, (input.Attributes !== undefined && {
        Attributes: serializeAws_restJson1_1MapOfAttributeDimension(input.Attributes, context)
    })), (input.EventType !== undefined && {
        EventType: serializeAws_restJson1_1SetDimension(input.EventType, context)
    })), (input.Metrics !== undefined && {
        Metrics: serializeAws_restJson1_1MapOfMetricDimension(input.Metrics, context)
    }));
};
var serializeAws_restJson1_1EventsBatch = function (input, context) {
    return __assign(__assign({}, (input.Endpoint !== undefined && {
        Endpoint: serializeAws_restJson1_1PublicEndpoint(input.Endpoint, context)
    })), (input.Events !== undefined && {
        Events: serializeAws_restJson1_1MapOfEvent(input.Events, context)
    }));
};
var serializeAws_restJson1_1EventsRequest = function (input, context) {
    return __assign({}, (input.BatchItem !== undefined && {
        BatchItem: serializeAws_restJson1_1MapOfEventsBatch(input.BatchItem, context)
    }));
};
var serializeAws_restJson1_1ExportJobRequest = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.RoleArn !== undefined && { RoleArn: input.RoleArn })), (input.S3UrlPrefix !== undefined && { S3UrlPrefix: input.S3UrlPrefix })), (input.SegmentId !== undefined && { SegmentId: input.SegmentId })), (input.SegmentVersion !== undefined && {
        SegmentVersion: input.SegmentVersion
    }));
};
var serializeAws_restJson1_1GCMChannelRequest = function (input, context) {
    return __assign(__assign({}, (input.ApiKey !== undefined && { ApiKey: input.ApiKey })), (input.Enabled !== undefined && { Enabled: input.Enabled }));
};
var serializeAws_restJson1_1GCMMessage = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.Action !== undefined && { Action: input.Action })), (input.Body !== undefined && { Body: input.Body })), (input.CollapseKey !== undefined && { CollapseKey: input.CollapseKey })), (input.Data !== undefined && {
        Data: serializeAws_restJson1_1MapOf__string(input.Data, context)
    })), (input.IconReference !== undefined && {
        IconReference: input.IconReference
    })), (input.ImageIconUrl !== undefined && {
        ImageIconUrl: input.ImageIconUrl
    })), (input.ImageUrl !== undefined && { ImageUrl: input.ImageUrl })), (input.Priority !== undefined && { Priority: input.Priority })), (input.RawContent !== undefined && { RawContent: input.RawContent })), (input.RestrictedPackageName !== undefined && {
        RestrictedPackageName: input.RestrictedPackageName
    })), (input.SilentPush !== undefined && { SilentPush: input.SilentPush })), (input.SmallImageIconUrl !== undefined && {
        SmallImageIconUrl: input.SmallImageIconUrl
    })), (input.Sound !== undefined && { Sound: input.Sound })), (input.Substitutions !== undefined && {
        Substitutions: serializeAws_restJson1_1MapOfListOf__string(input.Substitutions, context)
    })), (input.TimeToLive !== undefined && { TimeToLive: input.TimeToLive })), (input.Title !== undefined && { Title: input.Title })), (input.Url !== undefined && { Url: input.Url }));
};
var serializeAws_restJson1_1GPSCoordinates = function (input, context) {
    return __assign(__assign({}, (input.Latitude !== undefined && { Latitude: input.Latitude })), (input.Longitude !== undefined && { Longitude: input.Longitude }));
};
var serializeAws_restJson1_1GPSPointDimension = function (input, context) {
    return __assign(__assign({}, (input.Coordinates !== undefined && {
        Coordinates: serializeAws_restJson1_1GPSCoordinates(input.Coordinates, context)
    })), (input.RangeInKilometers !== undefined && {
        RangeInKilometers: input.RangeInKilometers
    }));
};
var serializeAws_restJson1_1HoldoutActivity = function (input, context) {
    return __assign(__assign({}, (input.NextActivity !== undefined && {
        NextActivity: input.NextActivity
    })), (input.Percentage !== undefined && { Percentage: input.Percentage }));
};
var serializeAws_restJson1_1ImportJobRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.DefineSegment !== undefined && {
        DefineSegment: input.DefineSegment
    })), (input.ExternalId !== undefined && { ExternalId: input.ExternalId })), (input.Format !== undefined && { Format: input.Format })), (input.RegisterEndpoints !== undefined && {
        RegisterEndpoints: input.RegisterEndpoints
    })), (input.RoleArn !== undefined && { RoleArn: input.RoleArn })), (input.S3Url !== undefined && { S3Url: input.S3Url })), (input.SegmentId !== undefined && { SegmentId: input.SegmentId })), (input.SegmentName !== undefined && { SegmentName: input.SegmentName }));
};
var serializeAws_restJson1_1JourneyEmailMessage = function (input, context) {
    return __assign({}, (input.FromAddress !== undefined && { FromAddress: input.FromAddress }));
};
var serializeAws_restJson1_1JourneyLimits = function (input, context) {
    return __assign(__assign(__assign({}, (input.DailyCap !== undefined && { DailyCap: input.DailyCap })), (input.EndpointReentryCap !== undefined && {
        EndpointReentryCap: input.EndpointReentryCap
    })), (input.MessagesPerSecond !== undefined && {
        MessagesPerSecond: input.MessagesPerSecond
    }));
};
var serializeAws_restJson1_1JourneySchedule = function (input, context) {
    return __assign(__assign(__assign({}, (input.EndTime !== undefined && {
        EndTime: input.EndTime.toISOString().split(".")[0] + "Z"
    })), (input.StartTime !== undefined && {
        StartTime: input.StartTime.toISOString().split(".")[0] + "Z"
    })), (input.Timezone !== undefined && { Timezone: input.Timezone }));
};
var serializeAws_restJson1_1JourneyStateRequest = function (input, context) {
    return __assign({}, (input.State !== undefined && { State: input.State }));
};
var serializeAws_restJson1_1ListOfEndpointBatchItem = function (input, context) {
    return input.map(function (entry) {
        return serializeAws_restJson1_1EndpointBatchItem(entry, context);
    });
};
var serializeAws_restJson1_1ListOfMultiConditionalBranch = function (input, context) {
    return input.map(function (entry) {
        return serializeAws_restJson1_1MultiConditionalBranch(entry, context);
    });
};
var serializeAws_restJson1_1ListOfRandomSplitEntry = function (input, context) {
    return input.map(function (entry) {
        return serializeAws_restJson1_1RandomSplitEntry(entry, context);
    });
};
var serializeAws_restJson1_1ListOfSegmentDimensions = function (input, context) {
    return input.map(function (entry) {
        return serializeAws_restJson1_1SegmentDimensions(entry, context);
    });
};
var serializeAws_restJson1_1ListOfSegmentGroup = function (input, context) {
    return input.map(function (entry) {
        return serializeAws_restJson1_1SegmentGroup(entry, context);
    });
};
var serializeAws_restJson1_1ListOfSegmentReference = function (input, context) {
    return input.map(function (entry) {
        return serializeAws_restJson1_1SegmentReference(entry, context);
    });
};
var serializeAws_restJson1_1ListOfSimpleCondition = function (input, context) {
    return input.map(function (entry) {
        return serializeAws_restJson1_1SimpleCondition(entry, context);
    });
};
var serializeAws_restJson1_1ListOfWriteTreatmentResource = function (input, context) {
    return input.map(function (entry) {
        return serializeAws_restJson1_1WriteTreatmentResource(entry, context);
    });
};
var serializeAws_restJson1_1ListOf__string = function (input, context) {
    return input.map(function (entry) { return entry; });
};
var serializeAws_restJson1_1MapOfActivity = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1_1Activity(value, context), _b)));
    }, {});
};
var serializeAws_restJson1_1MapOfAddressConfiguration = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1_1AddressConfiguration(value, context), _b)));
    }, {});
};
var serializeAws_restJson1_1MapOfAttributeDimension = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1_1AttributeDimension(value, context), _b)));
    }, {});
};
var serializeAws_restJson1_1MapOfEndpointSendConfiguration = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1_1EndpointSendConfiguration(value, context), _b)));
    }, {});
};
var serializeAws_restJson1_1MapOfEvent = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1_1Event(value, context), _b)));
    }, {});
};
var serializeAws_restJson1_1MapOfEventsBatch = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1_1EventsBatch(value, context), _b)));
    }, {});
};
var serializeAws_restJson1_1MapOfListOf__string = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1_1ListOf__string(value, context), _b)));
    }, {});
};
var serializeAws_restJson1_1MapOfMetricDimension = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = serializeAws_restJson1_1MetricDimension(value, context), _b)));
    }, {});
};
var serializeAws_restJson1_1MapOf__double = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
    }, {});
};
var serializeAws_restJson1_1MapOf__string = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
    }, {});
};
var serializeAws_restJson1_1Message = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.Action !== undefined && { Action: input.Action })), (input.Body !== undefined && { Body: input.Body })), (input.ImageIconUrl !== undefined && {
        ImageIconUrl: input.ImageIconUrl
    })), (input.ImageSmallIconUrl !== undefined && {
        ImageSmallIconUrl: input.ImageSmallIconUrl
    })), (input.ImageUrl !== undefined && { ImageUrl: input.ImageUrl })), (input.JsonBody !== undefined && { JsonBody: input.JsonBody })), (input.MediaUrl !== undefined && { MediaUrl: input.MediaUrl })), (input.RawContent !== undefined && { RawContent: input.RawContent })), (input.SilentPush !== undefined && { SilentPush: input.SilentPush })), (input.TimeToLive !== undefined && { TimeToLive: input.TimeToLive })), (input.Title !== undefined && { Title: input.Title })), (input.Url !== undefined && { Url: input.Url }));
};
var serializeAws_restJson1_1MessageConfiguration = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.ADMMessage !== undefined && {
        ADMMessage: serializeAws_restJson1_1Message(input.ADMMessage, context)
    })), (input.APNSMessage !== undefined && {
        APNSMessage: serializeAws_restJson1_1Message(input.APNSMessage, context)
    })), (input.BaiduMessage !== undefined && {
        BaiduMessage: serializeAws_restJson1_1Message(input.BaiduMessage, context)
    })), (input.DefaultMessage !== undefined && {
        DefaultMessage: serializeAws_restJson1_1Message(input.DefaultMessage, context)
    })), (input.EmailMessage !== undefined && {
        EmailMessage: serializeAws_restJson1_1CampaignEmailMessage(input.EmailMessage, context)
    })), (input.GCMMessage !== undefined && {
        GCMMessage: serializeAws_restJson1_1Message(input.GCMMessage, context)
    })), (input.SMSMessage !== undefined && {
        SMSMessage: serializeAws_restJson1_1CampaignSmsMessage(input.SMSMessage, context)
    }));
};
var serializeAws_restJson1_1MessageRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.Addresses !== undefined && {
        Addresses: serializeAws_restJson1_1MapOfAddressConfiguration(input.Addresses, context)
    })), (input.Context !== undefined && {
        Context: serializeAws_restJson1_1MapOf__string(input.Context, context)
    })), (input.Endpoints !== undefined && {
        Endpoints: serializeAws_restJson1_1MapOfEndpointSendConfiguration(input.Endpoints, context)
    })), (input.MessageConfiguration !== undefined && {
        MessageConfiguration: serializeAws_restJson1_1DirectMessageConfiguration(input.MessageConfiguration, context)
    })), (input.TemplateConfiguration !== undefined && {
        TemplateConfiguration: serializeAws_restJson1_1TemplateConfiguration(input.TemplateConfiguration, context)
    })), (input.TraceId !== undefined && { TraceId: input.TraceId }));
};
var serializeAws_restJson1_1MetricDimension = function (input, context) {
    return __assign(__assign({}, (input.ComparisonOperator !== undefined && {
        ComparisonOperator: input.ComparisonOperator
    })), (input.Value !== undefined && { Value: input.Value }));
};
var serializeAws_restJson1_1MultiConditionalBranch = function (input, context) {
    return __assign(__assign({}, (input.Condition !== undefined && {
        Condition: serializeAws_restJson1_1SimpleCondition(input.Condition, context)
    })), (input.NextActivity !== undefined && {
        NextActivity: input.NextActivity
    }));
};
var serializeAws_restJson1_1MultiConditionalSplitActivity = function (input, context) {
    return __assign(__assign(__assign({}, (input.Branches !== undefined && {
        Branches: serializeAws_restJson1_1ListOfMultiConditionalBranch(input.Branches, context)
    })), (input.DefaultActivity !== undefined && {
        DefaultActivity: input.DefaultActivity
    })), (input.EvaluationWaitTime !== undefined && {
        EvaluationWaitTime: serializeAws_restJson1_1WaitTime(input.EvaluationWaitTime, context)
    }));
};
var serializeAws_restJson1_1NumberValidateRequest = function (input, context) {
    return __assign(__assign({}, (input.IsoCountryCode !== undefined && {
        IsoCountryCode: input.IsoCountryCode
    })), (input.PhoneNumber !== undefined && { PhoneNumber: input.PhoneNumber }));
};
var serializeAws_restJson1_1PublicEndpoint = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.Address !== undefined && { Address: input.Address })), (input.Attributes !== undefined && {
        Attributes: serializeAws_restJson1_1MapOfListOf__string(input.Attributes, context)
    })), (input.ChannelType !== undefined && { ChannelType: input.ChannelType })), (input.Demographic !== undefined && {
        Demographic: serializeAws_restJson1_1EndpointDemographic(input.Demographic, context)
    })), (input.EffectiveDate !== undefined && {
        EffectiveDate: input.EffectiveDate
    })), (input.EndpointStatus !== undefined && {
        EndpointStatus: input.EndpointStatus
    })), (input.Location !== undefined && {
        Location: serializeAws_restJson1_1EndpointLocation(input.Location, context)
    })), (input.Metrics !== undefined && {
        Metrics: serializeAws_restJson1_1MapOf__double(input.Metrics, context)
    })), (input.OptOut !== undefined && { OptOut: input.OptOut })), (input.RequestId !== undefined && { RequestId: input.RequestId })), (input.User !== undefined && {
        User: serializeAws_restJson1_1EndpointUser(input.User, context)
    }));
};
var serializeAws_restJson1_1PushNotificationTemplateRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.ADM !== undefined && {
        ADM: serializeAws_restJson1_1AndroidPushNotificationTemplate(input.ADM, context)
    })), (input.APNS !== undefined && {
        APNS: serializeAws_restJson1_1APNSPushNotificationTemplate(input.APNS, context)
    })), (input.Baidu !== undefined && {
        Baidu: serializeAws_restJson1_1AndroidPushNotificationTemplate(input.Baidu, context)
    })), (input.Default !== undefined && {
        Default: serializeAws_restJson1_1DefaultPushNotificationTemplate(input.Default, context)
    })), (input.DefaultSubstitutions !== undefined && {
        DefaultSubstitutions: input.DefaultSubstitutions
    })), (input.GCM !== undefined && {
        GCM: serializeAws_restJson1_1AndroidPushNotificationTemplate(input.GCM, context)
    })), (input.TemplateDescription !== undefined && {
        TemplateDescription: input.TemplateDescription
    })), (input.tags !== undefined && {
        tags: serializeAws_restJson1_1MapOf__string(input.tags, context)
    }));
};
var serializeAws_restJson1_1QuietTime = function (input, context) {
    return __assign(__assign({}, (input.End !== undefined && { End: input.End })), (input.Start !== undefined && { Start: input.Start }));
};
var serializeAws_restJson1_1RandomSplitActivity = function (input, context) {
    return __assign({}, (input.Branches !== undefined && {
        Branches: serializeAws_restJson1_1ListOfRandomSplitEntry(input.Branches, context)
    }));
};
var serializeAws_restJson1_1RandomSplitEntry = function (input, context) {
    return __assign(__assign({}, (input.NextActivity !== undefined && {
        NextActivity: input.NextActivity
    })), (input.Percentage !== undefined && { Percentage: input.Percentage }));
};
var serializeAws_restJson1_1RawEmail = function (input, context) {
    return __assign({}, (input.Data !== undefined && { Data: context.base64Encoder(input.Data) }));
};
var serializeAws_restJson1_1RecencyDimension = function (input, context) {
    return __assign(__assign({}, (input.Duration !== undefined && { Duration: input.Duration })), (input.RecencyType !== undefined && { RecencyType: input.RecencyType }));
};
var serializeAws_restJson1_1SMSChannelRequest = function (input, context) {
    return __assign(__assign(__assign({}, (input.Enabled !== undefined && { Enabled: input.Enabled })), (input.SenderId !== undefined && { SenderId: input.SenderId })), (input.ShortCode !== undefined && { ShortCode: input.ShortCode }));
};
var serializeAws_restJson1_1SMSMessage = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.Body !== undefined && { Body: input.Body })), (input.Keyword !== undefined && { Keyword: input.Keyword })), (input.MessageType !== undefined && { MessageType: input.MessageType })), (input.OriginationNumber !== undefined && {
        OriginationNumber: input.OriginationNumber
    })), (input.SenderId !== undefined && { SenderId: input.SenderId })), (input.Substitutions !== undefined && {
        Substitutions: serializeAws_restJson1_1MapOfListOf__string(input.Substitutions, context)
    }));
};
var serializeAws_restJson1_1SMSTemplateRequest = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.Body !== undefined && { Body: input.Body })), (input.DefaultSubstitutions !== undefined && {
        DefaultSubstitutions: input.DefaultSubstitutions
    })), (input.TemplateDescription !== undefined && {
        TemplateDescription: input.TemplateDescription
    })), (input.tags !== undefined && {
        tags: serializeAws_restJson1_1MapOf__string(input.tags, context)
    }));
};
var serializeAws_restJson1_1Schedule = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.EndTime !== undefined && { EndTime: input.EndTime })), (input.EventFilter !== undefined && {
        EventFilter: serializeAws_restJson1_1CampaignEventFilter(input.EventFilter, context)
    })), (input.Frequency !== undefined && { Frequency: input.Frequency })), (input.IsLocalTime !== undefined && { IsLocalTime: input.IsLocalTime })), (input.QuietTime !== undefined && {
        QuietTime: serializeAws_restJson1_1QuietTime(input.QuietTime, context)
    })), (input.StartTime !== undefined && { StartTime: input.StartTime })), (input.Timezone !== undefined && { Timezone: input.Timezone }));
};
var serializeAws_restJson1_1SegmentBehaviors = function (input, context) {
    return __assign({}, (input.Recency !== undefined && {
        Recency: serializeAws_restJson1_1RecencyDimension(input.Recency, context)
    }));
};
var serializeAws_restJson1_1SegmentCondition = function (input, context) {
    return __assign({}, (input.SegmentId !== undefined && { SegmentId: input.SegmentId }));
};
var serializeAws_restJson1_1SegmentDemographics = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.AppVersion !== undefined && {
        AppVersion: serializeAws_restJson1_1SetDimension(input.AppVersion, context)
    })), (input.Channel !== undefined && {
        Channel: serializeAws_restJson1_1SetDimension(input.Channel, context)
    })), (input.DeviceType !== undefined && {
        DeviceType: serializeAws_restJson1_1SetDimension(input.DeviceType, context)
    })), (input.Make !== undefined && {
        Make: serializeAws_restJson1_1SetDimension(input.Make, context)
    })), (input.Model !== undefined && {
        Model: serializeAws_restJson1_1SetDimension(input.Model, context)
    })), (input.Platform !== undefined && {
        Platform: serializeAws_restJson1_1SetDimension(input.Platform, context)
    }));
};
var serializeAws_restJson1_1SegmentDimensions = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.Attributes !== undefined && {
        Attributes: serializeAws_restJson1_1MapOfAttributeDimension(input.Attributes, context)
    })), (input.Behavior !== undefined && {
        Behavior: serializeAws_restJson1_1SegmentBehaviors(input.Behavior, context)
    })), (input.Demographic !== undefined && {
        Demographic: serializeAws_restJson1_1SegmentDemographics(input.Demographic, context)
    })), (input.Location !== undefined && {
        Location: serializeAws_restJson1_1SegmentLocation(input.Location, context)
    })), (input.Metrics !== undefined && {
        Metrics: serializeAws_restJson1_1MapOfMetricDimension(input.Metrics, context)
    })), (input.UserAttributes !== undefined && {
        UserAttributes: serializeAws_restJson1_1MapOfAttributeDimension(input.UserAttributes, context)
    }));
};
var serializeAws_restJson1_1SegmentGroup = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.Dimensions !== undefined && {
        Dimensions: serializeAws_restJson1_1ListOfSegmentDimensions(input.Dimensions, context)
    })), (input.SourceSegments !== undefined && {
        SourceSegments: serializeAws_restJson1_1ListOfSegmentReference(input.SourceSegments, context)
    })), (input.SourceType !== undefined && { SourceType: input.SourceType })), (input.Type !== undefined && { Type: input.Type }));
};
var serializeAws_restJson1_1SegmentGroupList = function (input, context) {
    return __assign(__assign({}, (input.Groups !== undefined && {
        Groups: serializeAws_restJson1_1ListOfSegmentGroup(input.Groups, context)
    })), (input.Include !== undefined && { Include: input.Include }));
};
var serializeAws_restJson1_1SegmentLocation = function (input, context) {
    return __assign(__assign({}, (input.Country !== undefined && {
        Country: serializeAws_restJson1_1SetDimension(input.Country, context)
    })), (input.GPSPoint !== undefined && {
        GPSPoint: serializeAws_restJson1_1GPSPointDimension(input.GPSPoint, context)
    }));
};
var serializeAws_restJson1_1SegmentReference = function (input, context) {
    return __assign(__assign({}, (input.Id !== undefined && { Id: input.Id })), (input.Version !== undefined && { Version: input.Version }));
};
var serializeAws_restJson1_1SendUsersMessageRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign({}, (input.Context !== undefined && {
        Context: serializeAws_restJson1_1MapOf__string(input.Context, context)
    })), (input.MessageConfiguration !== undefined && {
        MessageConfiguration: serializeAws_restJson1_1DirectMessageConfiguration(input.MessageConfiguration, context)
    })), (input.TemplateConfiguration !== undefined && {
        TemplateConfiguration: serializeAws_restJson1_1TemplateConfiguration(input.TemplateConfiguration, context)
    })), (input.TraceId !== undefined && { TraceId: input.TraceId })), (input.Users !== undefined && {
        Users: serializeAws_restJson1_1MapOfEndpointSendConfiguration(input.Users, context)
    }));
};
var serializeAws_restJson1_1Session = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.Duration !== undefined && { Duration: input.Duration })), (input.Id !== undefined && { Id: input.Id })), (input.StartTimestamp !== undefined && {
        StartTimestamp: input.StartTimestamp
    })), (input.StopTimestamp !== undefined && {
        StopTimestamp: input.StopTimestamp
    }));
};
var serializeAws_restJson1_1SetDimension = function (input, context) {
    return __assign(__assign({}, (input.DimensionType !== undefined && {
        DimensionType: input.DimensionType
    })), (input.Values !== undefined && {
        Values: serializeAws_restJson1_1ListOf__string(input.Values, context)
    }));
};
var serializeAws_restJson1_1SimpleCondition = function (input, context) {
    return __assign(__assign(__assign({}, (input.EventCondition !== undefined && {
        EventCondition: serializeAws_restJson1_1EventCondition(input.EventCondition, context)
    })), (input.SegmentCondition !== undefined && {
        SegmentCondition: serializeAws_restJson1_1SegmentCondition(input.SegmentCondition, context)
    })), (input.SegmentDimensions !== undefined && {
        segmentDimensions: serializeAws_restJson1_1SegmentDimensions(input.SegmentDimensions, context)
    }));
};
var serializeAws_restJson1_1SimpleEmail = function (input, context) {
    return __assign(__assign(__assign({}, (input.HtmlPart !== undefined && {
        HtmlPart: serializeAws_restJson1_1SimpleEmailPart(input.HtmlPart, context)
    })), (input.Subject !== undefined && {
        Subject: serializeAws_restJson1_1SimpleEmailPart(input.Subject, context)
    })), (input.TextPart !== undefined && {
        TextPart: serializeAws_restJson1_1SimpleEmailPart(input.TextPart, context)
    }));
};
var serializeAws_restJson1_1SimpleEmailPart = function (input, context) {
    return __assign(__assign({}, (input.Charset !== undefined && { Charset: input.Charset })), (input.Data !== undefined && { Data: input.Data }));
};
var serializeAws_restJson1_1StartCondition = function (input, context) {
    return __assign(__assign({}, (input.Description !== undefined && { Description: input.Description })), (input.SegmentStartCondition !== undefined && {
        SegmentStartCondition: serializeAws_restJson1_1SegmentCondition(input.SegmentStartCondition, context)
    }));
};
var serializeAws_restJson1_1TagsModel = function (input, context) {
    return __assign({}, (input.tags !== undefined && {
        tags: serializeAws_restJson1_1MapOf__string(input.tags, context)
    }));
};
var serializeAws_restJson1_1Template = function (input, context) {
    return __assign(__assign({}, (input.Name !== undefined && { Name: input.Name })), (input.Version !== undefined && { Version: input.Version }));
};
var serializeAws_restJson1_1TemplateActiveVersionRequest = function (input, context) {
    return __assign({}, (input.Version !== undefined && { Version: input.Version }));
};
var serializeAws_restJson1_1TemplateConfiguration = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.EmailTemplate !== undefined && {
        EmailTemplate: serializeAws_restJson1_1Template(input.EmailTemplate, context)
    })), (input.PushTemplate !== undefined && {
        PushTemplate: serializeAws_restJson1_1Template(input.PushTemplate, context)
    })), (input.SMSTemplate !== undefined && {
        SMSTemplate: serializeAws_restJson1_1Template(input.SMSTemplate, context)
    })), (input.VoiceTemplate !== undefined && {
        VoiceTemplate: serializeAws_restJson1_1Template(input.VoiceTemplate, context)
    }));
};
var serializeAws_restJson1_1UpdateAttributesRequest = function (input, context) {
    return __assign({}, (input.Blacklist !== undefined && {
        Blacklist: serializeAws_restJson1_1ListOf__string(input.Blacklist, context)
    }));
};
var serializeAws_restJson1_1VoiceChannelRequest = function (input, context) {
    return __assign({}, (input.Enabled !== undefined && { Enabled: input.Enabled }));
};
var serializeAws_restJson1_1VoiceMessage = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign({}, (input.Body !== undefined && { Body: input.Body })), (input.LanguageCode !== undefined && {
        LanguageCode: input.LanguageCode
    })), (input.OriginationNumber !== undefined && {
        OriginationNumber: input.OriginationNumber
    })), (input.Substitutions !== undefined && {
        Substitutions: serializeAws_restJson1_1MapOfListOf__string(input.Substitutions, context)
    })), (input.VoiceId !== undefined && { VoiceId: input.VoiceId }));
};
var serializeAws_restJson1_1VoiceTemplateRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.Body !== undefined && { Body: input.Body })), (input.DefaultSubstitutions !== undefined && {
        DefaultSubstitutions: input.DefaultSubstitutions
    })), (input.LanguageCode !== undefined && {
        LanguageCode: input.LanguageCode
    })), (input.TemplateDescription !== undefined && {
        TemplateDescription: input.TemplateDescription
    })), (input.VoiceId !== undefined && { VoiceId: input.VoiceId })), (input.tags !== undefined && {
        tags: serializeAws_restJson1_1MapOf__string(input.tags, context)
    }));
};
var serializeAws_restJson1_1WaitActivity = function (input, context) {
    return __assign(__assign({}, (input.NextActivity !== undefined && {
        NextActivity: input.NextActivity
    })), (input.WaitTime !== undefined && {
        WaitTime: serializeAws_restJson1_1WaitTime(input.WaitTime, context)
    }));
};
var serializeAws_restJson1_1WaitTime = function (input, context) {
    return __assign(__assign({}, (input.WaitFor !== undefined && { WaitFor: input.WaitFor })), (input.WaitUntil !== undefined && { WaitUntil: input.WaitUntil }));
};
var serializeAws_restJson1_1WriteApplicationSettingsRequest = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.CampaignHook !== undefined && {
        CampaignHook: serializeAws_restJson1_1CampaignHook(input.CampaignHook, context)
    })), (input.CloudWatchMetricsEnabled !== undefined && {
        CloudWatchMetricsEnabled: input.CloudWatchMetricsEnabled
    })), (input.Limits !== undefined && {
        Limits: serializeAws_restJson1_1CampaignLimits(input.Limits, context)
    })), (input.QuietTime !== undefined && {
        QuietTime: serializeAws_restJson1_1QuietTime(input.QuietTime, context)
    }));
};
var serializeAws_restJson1_1WriteCampaignRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.AdditionalTreatments !== undefined && {
        AdditionalTreatments: serializeAws_restJson1_1ListOfWriteTreatmentResource(input.AdditionalTreatments, context)
    })), (input.Description !== undefined && { Description: input.Description })), (input.HoldoutPercent !== undefined && {
        HoldoutPercent: input.HoldoutPercent
    })), (input.Hook !== undefined && {
        Hook: serializeAws_restJson1_1CampaignHook(input.Hook, context)
    })), (input.IsPaused !== undefined && { IsPaused: input.IsPaused })), (input.Limits !== undefined && {
        Limits: serializeAws_restJson1_1CampaignLimits(input.Limits, context)
    })), (input.MessageConfiguration !== undefined && {
        MessageConfiguration: serializeAws_restJson1_1MessageConfiguration(input.MessageConfiguration, context)
    })), (input.Name !== undefined && { Name: input.Name })), (input.Schedule !== undefined && {
        Schedule: serializeAws_restJson1_1Schedule(input.Schedule, context)
    })), (input.SegmentId !== undefined && { SegmentId: input.SegmentId })), (input.SegmentVersion !== undefined && {
        SegmentVersion: input.SegmentVersion
    })), (input.TemplateConfiguration !== undefined && {
        TemplateConfiguration: serializeAws_restJson1_1TemplateConfiguration(input.TemplateConfiguration, context)
    })), (input.TreatmentDescription !== undefined && {
        TreatmentDescription: input.TreatmentDescription
    })), (input.TreatmentName !== undefined && {
        TreatmentName: input.TreatmentName
    })), (input.tags !== undefined && {
        tags: serializeAws_restJson1_1MapOf__string(input.tags, context)
    }));
};
var serializeAws_restJson1_1WriteEventStream = function (input, context) {
    return __assign(__assign({}, (input.DestinationStreamArn !== undefined && {
        DestinationStreamArn: input.DestinationStreamArn
    })), (input.RoleArn !== undefined && { RoleArn: input.RoleArn }));
};
var serializeAws_restJson1_1WriteJourneyRequest = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (input.Activities !== undefined && {
        Activities: serializeAws_restJson1_1MapOfActivity(input.Activities, context)
    })), (input.CreationDate !== undefined && {
        CreationDate: input.CreationDate
    })), (input.LastModifiedDate !== undefined && {
        LastModifiedDate: input.LastModifiedDate
    })), (input.Limits !== undefined && {
        Limits: serializeAws_restJson1_1JourneyLimits(input.Limits, context)
    })), (input.LocalTime !== undefined && { LocalTime: input.LocalTime })), (input.Name !== undefined && { Name: input.Name })), (input.QuietTime !== undefined && {
        QuietTime: serializeAws_restJson1_1QuietTime(input.QuietTime, context)
    })), (input.RefreshFrequency !== undefined && {
        RefreshFrequency: input.RefreshFrequency
    })), (input.Schedule !== undefined && {
        Schedule: serializeAws_restJson1_1JourneySchedule(input.Schedule, context)
    })), (input.StartActivity !== undefined && {
        StartActivity: input.StartActivity
    })), (input.StartCondition !== undefined && {
        StartCondition: serializeAws_restJson1_1StartCondition(input.StartCondition, context)
    })), (input.State !== undefined && { State: input.State }));
};
var serializeAws_restJson1_1WriteSegmentRequest = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.Dimensions !== undefined && {
        Dimensions: serializeAws_restJson1_1SegmentDimensions(input.Dimensions, context)
    })), (input.Name !== undefined && { Name: input.Name })), (input.SegmentGroups !== undefined && {
        SegmentGroups: serializeAws_restJson1_1SegmentGroupList(input.SegmentGroups, context)
    })), (input.tags !== undefined && {
        tags: serializeAws_restJson1_1MapOf__string(input.tags, context)
    }));
};
var serializeAws_restJson1_1WriteTreatmentResource = function (input, context) {
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (input.MessageConfiguration !== undefined && {
        MessageConfiguration: serializeAws_restJson1_1MessageConfiguration(input.MessageConfiguration, context)
    })), (input.Schedule !== undefined && {
        Schedule: serializeAws_restJson1_1Schedule(input.Schedule, context)
    })), (input.SizePercent !== undefined && { SizePercent: input.SizePercent })), (input.TemplateConfiguration !== undefined && {
        TemplateConfiguration: serializeAws_restJson1_1TemplateConfiguration(input.TemplateConfiguration, context)
    })), (input.TreatmentDescription !== undefined && {
        TreatmentDescription: input.TreatmentDescription
    })), (input.TreatmentName !== undefined && {
        TreatmentName: input.TreatmentName
    }));
};
var deserializeAws_restJson1_1ADMChannelResponse = function (output, context) {
    return {
        __type: "ADMChannelResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Enabled: output.Enabled !== undefined && output.Enabled !== null
            ? output.Enabled
            : undefined,
        HasCredential: output.HasCredential !== undefined && output.HasCredential !== null
            ? output.HasCredential
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        IsArchived: output.IsArchived !== undefined && output.IsArchived !== null
            ? output.IsArchived
            : undefined,
        LastModifiedBy: output.LastModifiedBy !== undefined && output.LastModifiedBy !== null
            ? output.LastModifiedBy
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Platform: output.Platform !== undefined && output.Platform !== null
            ? output.Platform
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1APNSChannelResponse = function (output, context) {
    return {
        __type: "APNSChannelResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        DefaultAuthenticationMethod: output.DefaultAuthenticationMethod !== undefined &&
            output.DefaultAuthenticationMethod !== null
            ? output.DefaultAuthenticationMethod
            : undefined,
        Enabled: output.Enabled !== undefined && output.Enabled !== null
            ? output.Enabled
            : undefined,
        HasCredential: output.HasCredential !== undefined && output.HasCredential !== null
            ? output.HasCredential
            : undefined,
        HasTokenKey: output.HasTokenKey !== undefined && output.HasTokenKey !== null
            ? output.HasTokenKey
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        IsArchived: output.IsArchived !== undefined && output.IsArchived !== null
            ? output.IsArchived
            : undefined,
        LastModifiedBy: output.LastModifiedBy !== undefined && output.LastModifiedBy !== null
            ? output.LastModifiedBy
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Platform: output.Platform !== undefined && output.Platform !== null
            ? output.Platform
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1APNSPushNotificationTemplate = function (output, context) {
    return {
        __type: "APNSPushNotificationTemplate",
        Action: output.Action !== undefined && output.Action !== null
            ? output.Action
            : undefined,
        Body: output.Body !== undefined && output.Body !== null
            ? output.Body
            : undefined,
        MediaUrl: output.MediaUrl !== undefined && output.MediaUrl !== null
            ? output.MediaUrl
            : undefined,
        RawContent: output.RawContent !== undefined && output.RawContent !== null
            ? output.RawContent
            : undefined,
        Sound: output.Sound !== undefined && output.Sound !== null
            ? output.Sound
            : undefined,
        Title: output.Title !== undefined && output.Title !== null
            ? output.Title
            : undefined,
        Url: output.Url !== undefined && output.Url !== null ? output.Url : undefined
    };
};
var deserializeAws_restJson1_1APNSSandboxChannelResponse = function (output, context) {
    return {
        __type: "APNSSandboxChannelResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        DefaultAuthenticationMethod: output.DefaultAuthenticationMethod !== undefined &&
            output.DefaultAuthenticationMethod !== null
            ? output.DefaultAuthenticationMethod
            : undefined,
        Enabled: output.Enabled !== undefined && output.Enabled !== null
            ? output.Enabled
            : undefined,
        HasCredential: output.HasCredential !== undefined && output.HasCredential !== null
            ? output.HasCredential
            : undefined,
        HasTokenKey: output.HasTokenKey !== undefined && output.HasTokenKey !== null
            ? output.HasTokenKey
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        IsArchived: output.IsArchived !== undefined && output.IsArchived !== null
            ? output.IsArchived
            : undefined,
        LastModifiedBy: output.LastModifiedBy !== undefined && output.LastModifiedBy !== null
            ? output.LastModifiedBy
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Platform: output.Platform !== undefined && output.Platform !== null
            ? output.Platform
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1APNSVoipChannelResponse = function (output, context) {
    return {
        __type: "APNSVoipChannelResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        DefaultAuthenticationMethod: output.DefaultAuthenticationMethod !== undefined &&
            output.DefaultAuthenticationMethod !== null
            ? output.DefaultAuthenticationMethod
            : undefined,
        Enabled: output.Enabled !== undefined && output.Enabled !== null
            ? output.Enabled
            : undefined,
        HasCredential: output.HasCredential !== undefined && output.HasCredential !== null
            ? output.HasCredential
            : undefined,
        HasTokenKey: output.HasTokenKey !== undefined && output.HasTokenKey !== null
            ? output.HasTokenKey
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        IsArchived: output.IsArchived !== undefined && output.IsArchived !== null
            ? output.IsArchived
            : undefined,
        LastModifiedBy: output.LastModifiedBy !== undefined && output.LastModifiedBy !== null
            ? output.LastModifiedBy
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Platform: output.Platform !== undefined && output.Platform !== null
            ? output.Platform
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1APNSVoipSandboxChannelResponse = function (output, context) {
    return {
        __type: "APNSVoipSandboxChannelResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        DefaultAuthenticationMethod: output.DefaultAuthenticationMethod !== undefined &&
            output.DefaultAuthenticationMethod !== null
            ? output.DefaultAuthenticationMethod
            : undefined,
        Enabled: output.Enabled !== undefined && output.Enabled !== null
            ? output.Enabled
            : undefined,
        HasCredential: output.HasCredential !== undefined && output.HasCredential !== null
            ? output.HasCredential
            : undefined,
        HasTokenKey: output.HasTokenKey !== undefined && output.HasTokenKey !== null
            ? output.HasTokenKey
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        IsArchived: output.IsArchived !== undefined && output.IsArchived !== null
            ? output.IsArchived
            : undefined,
        LastModifiedBy: output.LastModifiedBy !== undefined && output.LastModifiedBy !== null
            ? output.LastModifiedBy
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Platform: output.Platform !== undefined && output.Platform !== null
            ? output.Platform
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1ActivitiesResponse = function (output, context) {
    return {
        __type: "ActivitiesResponse",
        Item: output.Item !== undefined && output.Item !== null
            ? deserializeAws_restJson1_1ListOfActivityResponse(output.Item, context)
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null
            ? output.NextToken
            : undefined
    };
};
var deserializeAws_restJson1_1Activity = function (output, context) {
    return {
        __type: "Activity",
        ConditionalSplit: output.ConditionalSplit !== undefined && output.ConditionalSplit !== null
            ? deserializeAws_restJson1_1ConditionalSplitActivity(output.ConditionalSplit, context)
            : undefined,
        Description: output.Description !== undefined && output.Description !== null
            ? output.Description
            : undefined,
        EMAIL: output.EMAIL !== undefined && output.EMAIL !== null
            ? deserializeAws_restJson1_1EmailMessageActivity(output.EMAIL, context)
            : undefined,
        Holdout: output.Holdout !== undefined && output.Holdout !== null
            ? deserializeAws_restJson1_1HoldoutActivity(output.Holdout, context)
            : undefined,
        MultiCondition: output.MultiCondition !== undefined && output.MultiCondition !== null
            ? deserializeAws_restJson1_1MultiConditionalSplitActivity(output.MultiCondition, context)
            : undefined,
        RandomSplit: output.RandomSplit !== undefined && output.RandomSplit !== null
            ? deserializeAws_restJson1_1RandomSplitActivity(output.RandomSplit, context)
            : undefined,
        Wait: output.Wait !== undefined && output.Wait !== null
            ? deserializeAws_restJson1_1WaitActivity(output.Wait, context)
            : undefined
    };
};
var deserializeAws_restJson1_1ActivityResponse = function (output, context) {
    return {
        __type: "ActivityResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CampaignId: output.CampaignId !== undefined && output.CampaignId !== null
            ? output.CampaignId
            : undefined,
        End: output.End !== undefined && output.End !== null ? output.End : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        Result: output.Result !== undefined && output.Result !== null
            ? output.Result
            : undefined,
        ScheduledStart: output.ScheduledStart !== undefined && output.ScheduledStart !== null
            ? output.ScheduledStart
            : undefined,
        Start: output.Start !== undefined && output.Start !== null
            ? output.Start
            : undefined,
        State: output.State !== undefined && output.State !== null
            ? output.State
            : undefined,
        SuccessfulEndpointCount: output.SuccessfulEndpointCount !== undefined &&
            output.SuccessfulEndpointCount !== null
            ? output.SuccessfulEndpointCount
            : undefined,
        TimezonesCompletedCount: output.TimezonesCompletedCount !== undefined &&
            output.TimezonesCompletedCount !== null
            ? output.TimezonesCompletedCount
            : undefined,
        TimezonesTotalCount: output.TimezonesTotalCount !== undefined &&
            output.TimezonesTotalCount !== null
            ? output.TimezonesTotalCount
            : undefined,
        TotalEndpointCount: output.TotalEndpointCount !== undefined &&
            output.TotalEndpointCount !== null
            ? output.TotalEndpointCount
            : undefined,
        TreatmentId: output.TreatmentId !== undefined && output.TreatmentId !== null
            ? output.TreatmentId
            : undefined
    };
};
var deserializeAws_restJson1_1AndroidPushNotificationTemplate = function (output, context) {
    return {
        __type: "AndroidPushNotificationTemplate",
        Action: output.Action !== undefined && output.Action !== null
            ? output.Action
            : undefined,
        Body: output.Body !== undefined && output.Body !== null
            ? output.Body
            : undefined,
        ImageIconUrl: output.ImageIconUrl !== undefined && output.ImageIconUrl !== null
            ? output.ImageIconUrl
            : undefined,
        ImageUrl: output.ImageUrl !== undefined && output.ImageUrl !== null
            ? output.ImageUrl
            : undefined,
        RawContent: output.RawContent !== undefined && output.RawContent !== null
            ? output.RawContent
            : undefined,
        SmallImageIconUrl: output.SmallImageIconUrl !== undefined &&
            output.SmallImageIconUrl !== null
            ? output.SmallImageIconUrl
            : undefined,
        Sound: output.Sound !== undefined && output.Sound !== null
            ? output.Sound
            : undefined,
        Title: output.Title !== undefined && output.Title !== null
            ? output.Title
            : undefined,
        Url: output.Url !== undefined && output.Url !== null ? output.Url : undefined
    };
};
var deserializeAws_restJson1_1ApplicationDateRangeKpiResponse = function (output, context) {
    return {
        __type: "ApplicationDateRangeKpiResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        EndTime: output.EndTime !== undefined && output.EndTime !== null
            ? new Date(output.EndTime)
            : undefined,
        KpiName: output.KpiName !== undefined && output.KpiName !== null
            ? output.KpiName
            : undefined,
        KpiResult: output.KpiResult !== undefined && output.KpiResult !== null
            ? deserializeAws_restJson1_1BaseKpiResult(output.KpiResult, context)
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null
            ? output.NextToken
            : undefined,
        StartTime: output.StartTime !== undefined && output.StartTime !== null
            ? new Date(output.StartTime)
            : undefined
    };
};
var deserializeAws_restJson1_1ApplicationResponse = function (output, context) {
    return {
        __type: "ApplicationResponse",
        Arn: output.Arn !== undefined && output.Arn !== null ? output.Arn : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        Name: output.Name !== undefined && output.Name !== null
            ? output.Name
            : undefined,
        tags: output.tags !== undefined && output.tags !== null
            ? deserializeAws_restJson1_1MapOf__string(output.tags, context)
            : undefined
    };
};
var deserializeAws_restJson1_1ApplicationSettingsResource = function (output, context) {
    return {
        __type: "ApplicationSettingsResource",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CampaignHook: output.CampaignHook !== undefined && output.CampaignHook !== null
            ? deserializeAws_restJson1_1CampaignHook(output.CampaignHook, context)
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Limits: output.Limits !== undefined && output.Limits !== null
            ? deserializeAws_restJson1_1CampaignLimits(output.Limits, context)
            : undefined,
        QuietTime: output.QuietTime !== undefined && output.QuietTime !== null
            ? deserializeAws_restJson1_1QuietTime(output.QuietTime, context)
            : undefined
    };
};
var deserializeAws_restJson1_1ApplicationsResponse = function (output, context) {
    return {
        __type: "ApplicationsResponse",
        Item: output.Item !== undefined && output.Item !== null
            ? deserializeAws_restJson1_1ListOfApplicationResponse(output.Item, context)
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null
            ? output.NextToken
            : undefined
    };
};
var deserializeAws_restJson1_1AttributeDimension = function (output, context) {
    return {
        __type: "AttributeDimension",
        AttributeType: output.AttributeType !== undefined && output.AttributeType !== null
            ? output.AttributeType
            : undefined,
        Values: output.Values !== undefined && output.Values !== null
            ? deserializeAws_restJson1_1ListOf__string(output.Values, context)
            : undefined
    };
};
var deserializeAws_restJson1_1AttributesResource = function (output, context) {
    return {
        __type: "AttributesResource",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        AttributeType: output.AttributeType !== undefined && output.AttributeType !== null
            ? output.AttributeType
            : undefined,
        Attributes: output.Attributes !== undefined && output.Attributes !== null
            ? deserializeAws_restJson1_1ListOf__string(output.Attributes, context)
            : undefined
    };
};
var deserializeAws_restJson1_1BaiduChannelResponse = function (output, context) {
    return {
        __type: "BaiduChannelResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Credential: output.Credential !== undefined && output.Credential !== null
            ? output.Credential
            : undefined,
        Enabled: output.Enabled !== undefined && output.Enabled !== null
            ? output.Enabled
            : undefined,
        HasCredential: output.HasCredential !== undefined && output.HasCredential !== null
            ? output.HasCredential
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        IsArchived: output.IsArchived !== undefined && output.IsArchived !== null
            ? output.IsArchived
            : undefined,
        LastModifiedBy: output.LastModifiedBy !== undefined && output.LastModifiedBy !== null
            ? output.LastModifiedBy
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Platform: output.Platform !== undefined && output.Platform !== null
            ? output.Platform
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1BaseKpiResult = function (output, context) {
    return {
        __type: "BaseKpiResult",
        Rows: output.Rows !== undefined && output.Rows !== null
            ? deserializeAws_restJson1_1ListOfResultRow(output.Rows, context)
            : undefined
    };
};
var deserializeAws_restJson1_1CampaignDateRangeKpiResponse = function (output, context) {
    return {
        __type: "CampaignDateRangeKpiResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CampaignId: output.CampaignId !== undefined && output.CampaignId !== null
            ? output.CampaignId
            : undefined,
        EndTime: output.EndTime !== undefined && output.EndTime !== null
            ? new Date(output.EndTime)
            : undefined,
        KpiName: output.KpiName !== undefined && output.KpiName !== null
            ? output.KpiName
            : undefined,
        KpiResult: output.KpiResult !== undefined && output.KpiResult !== null
            ? deserializeAws_restJson1_1BaseKpiResult(output.KpiResult, context)
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null
            ? output.NextToken
            : undefined,
        StartTime: output.StartTime !== undefined && output.StartTime !== null
            ? new Date(output.StartTime)
            : undefined
    };
};
var deserializeAws_restJson1_1CampaignEmailMessage = function (output, context) {
    return {
        __type: "CampaignEmailMessage",
        Body: output.Body !== undefined && output.Body !== null
            ? output.Body
            : undefined,
        FromAddress: output.FromAddress !== undefined && output.FromAddress !== null
            ? output.FromAddress
            : undefined,
        HtmlBody: output.HtmlBody !== undefined && output.HtmlBody !== null
            ? output.HtmlBody
            : undefined,
        Title: output.Title !== undefined && output.Title !== null
            ? output.Title
            : undefined
    };
};
var deserializeAws_restJson1_1CampaignEventFilter = function (output, context) {
    return {
        __type: "CampaignEventFilter",
        Dimensions: output.Dimensions !== undefined && output.Dimensions !== null
            ? deserializeAws_restJson1_1EventDimensions(output.Dimensions, context)
            : undefined,
        FilterType: output.FilterType !== undefined && output.FilterType !== null
            ? output.FilterType
            : undefined
    };
};
var deserializeAws_restJson1_1CampaignHook = function (output, context) {
    return {
        __type: "CampaignHook",
        LambdaFunctionName: output.LambdaFunctionName !== undefined &&
            output.LambdaFunctionName !== null
            ? output.LambdaFunctionName
            : undefined,
        Mode: output.Mode !== undefined && output.Mode !== null
            ? output.Mode
            : undefined,
        WebUrl: output.WebUrl !== undefined && output.WebUrl !== null
            ? output.WebUrl
            : undefined
    };
};
var deserializeAws_restJson1_1CampaignLimits = function (output, context) {
    return {
        __type: "CampaignLimits",
        Daily: output.Daily !== undefined && output.Daily !== null
            ? output.Daily
            : undefined,
        MaximumDuration: output.MaximumDuration !== undefined && output.MaximumDuration !== null
            ? output.MaximumDuration
            : undefined,
        MessagesPerSecond: output.MessagesPerSecond !== undefined &&
            output.MessagesPerSecond !== null
            ? output.MessagesPerSecond
            : undefined,
        Total: output.Total !== undefined && output.Total !== null
            ? output.Total
            : undefined
    };
};
var deserializeAws_restJson1_1CampaignResponse = function (output, context) {
    return {
        __type: "CampaignResponse",
        AdditionalTreatments: output.AdditionalTreatments !== undefined &&
            output.AdditionalTreatments !== null
            ? deserializeAws_restJson1_1ListOfTreatmentResource(output.AdditionalTreatments, context)
            : undefined,
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        Arn: output.Arn !== undefined && output.Arn !== null ? output.Arn : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        DefaultState: output.DefaultState !== undefined && output.DefaultState !== null
            ? deserializeAws_restJson1_1CampaignState(output.DefaultState, context)
            : undefined,
        Description: output.Description !== undefined && output.Description !== null
            ? output.Description
            : undefined,
        HoldoutPercent: output.HoldoutPercent !== undefined && output.HoldoutPercent !== null
            ? output.HoldoutPercent
            : undefined,
        Hook: output.Hook !== undefined && output.Hook !== null
            ? deserializeAws_restJson1_1CampaignHook(output.Hook, context)
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        IsPaused: output.IsPaused !== undefined && output.IsPaused !== null
            ? output.IsPaused
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Limits: output.Limits !== undefined && output.Limits !== null
            ? deserializeAws_restJson1_1CampaignLimits(output.Limits, context)
            : undefined,
        MessageConfiguration: output.MessageConfiguration !== undefined &&
            output.MessageConfiguration !== null
            ? deserializeAws_restJson1_1MessageConfiguration(output.MessageConfiguration, context)
            : undefined,
        Name: output.Name !== undefined && output.Name !== null
            ? output.Name
            : undefined,
        Schedule: output.Schedule !== undefined && output.Schedule !== null
            ? deserializeAws_restJson1_1Schedule(output.Schedule, context)
            : undefined,
        SegmentId: output.SegmentId !== undefined && output.SegmentId !== null
            ? output.SegmentId
            : undefined,
        SegmentVersion: output.SegmentVersion !== undefined && output.SegmentVersion !== null
            ? output.SegmentVersion
            : undefined,
        State: output.State !== undefined && output.State !== null
            ? deserializeAws_restJson1_1CampaignState(output.State, context)
            : undefined,
        TemplateConfiguration: output.TemplateConfiguration !== undefined &&
            output.TemplateConfiguration !== null
            ? deserializeAws_restJson1_1TemplateConfiguration(output.TemplateConfiguration, context)
            : undefined,
        TreatmentDescription: output.TreatmentDescription !== undefined &&
            output.TreatmentDescription !== null
            ? output.TreatmentDescription
            : undefined,
        TreatmentName: output.TreatmentName !== undefined && output.TreatmentName !== null
            ? output.TreatmentName
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined,
        tags: output.tags !== undefined && output.tags !== null
            ? deserializeAws_restJson1_1MapOf__string(output.tags, context)
            : undefined
    };
};
var deserializeAws_restJson1_1CampaignSmsMessage = function (output, context) {
    return {
        __type: "CampaignSmsMessage",
        Body: output.Body !== undefined && output.Body !== null
            ? output.Body
            : undefined,
        MessageType: output.MessageType !== undefined && output.MessageType !== null
            ? output.MessageType
            : undefined,
        SenderId: output.SenderId !== undefined && output.SenderId !== null
            ? output.SenderId
            : undefined
    };
};
var deserializeAws_restJson1_1CampaignState = function (output, context) {
    return {
        __type: "CampaignState",
        CampaignStatus: output.CampaignStatus !== undefined && output.CampaignStatus !== null
            ? output.CampaignStatus
            : undefined
    };
};
var deserializeAws_restJson1_1CampaignsResponse = function (output, context) {
    return {
        __type: "CampaignsResponse",
        Item: output.Item !== undefined && output.Item !== null
            ? deserializeAws_restJson1_1ListOfCampaignResponse(output.Item, context)
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null
            ? output.NextToken
            : undefined
    };
};
var deserializeAws_restJson1_1ChannelResponse = function (output, context) {
    return {
        __type: "ChannelResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Enabled: output.Enabled !== undefined && output.Enabled !== null
            ? output.Enabled
            : undefined,
        HasCredential: output.HasCredential !== undefined && output.HasCredential !== null
            ? output.HasCredential
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        IsArchived: output.IsArchived !== undefined && output.IsArchived !== null
            ? output.IsArchived
            : undefined,
        LastModifiedBy: output.LastModifiedBy !== undefined && output.LastModifiedBy !== null
            ? output.LastModifiedBy
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1ChannelsResponse = function (output, context) {
    return {
        __type: "ChannelsResponse",
        Channels: output.Channels !== undefined && output.Channels !== null
            ? deserializeAws_restJson1_1MapOfChannelResponse(output.Channels, context)
            : undefined
    };
};
var deserializeAws_restJson1_1Condition = function (output, context) {
    return {
        __type: "Condition",
        Conditions: output.Conditions !== undefined && output.Conditions !== null
            ? deserializeAws_restJson1_1ListOfSimpleCondition(output.Conditions, context)
            : undefined,
        Operator: output.Operator !== undefined && output.Operator !== null
            ? output.Operator
            : undefined
    };
};
var deserializeAws_restJson1_1ConditionalSplitActivity = function (output, context) {
    return {
        __type: "ConditionalSplitActivity",
        Condition: output.Condition !== undefined && output.Condition !== null
            ? deserializeAws_restJson1_1Condition(output.Condition, context)
            : undefined,
        EvaluationWaitTime: output.EvaluationWaitTime !== undefined &&
            output.EvaluationWaitTime !== null
            ? deserializeAws_restJson1_1WaitTime(output.EvaluationWaitTime, context)
            : undefined,
        FalseActivity: output.FalseActivity !== undefined && output.FalseActivity !== null
            ? output.FalseActivity
            : undefined,
        TrueActivity: output.TrueActivity !== undefined && output.TrueActivity !== null
            ? output.TrueActivity
            : undefined
    };
};
var deserializeAws_restJson1_1CreateTemplateMessageBody = function (output, context) {
    return {
        __type: "CreateTemplateMessageBody",
        Arn: output.Arn !== undefined && output.Arn !== null ? output.Arn : undefined,
        Message: output.Message !== undefined && output.Message !== null
            ? output.Message
            : undefined,
        RequestID: output.RequestID !== undefined && output.RequestID !== null
            ? output.RequestID
            : undefined
    };
};
var deserializeAws_restJson1_1DefaultPushNotificationTemplate = function (output, context) {
    return {
        __type: "DefaultPushNotificationTemplate",
        Action: output.Action !== undefined && output.Action !== null
            ? output.Action
            : undefined,
        Body: output.Body !== undefined && output.Body !== null
            ? output.Body
            : undefined,
        Sound: output.Sound !== undefined && output.Sound !== null
            ? output.Sound
            : undefined,
        Title: output.Title !== undefined && output.Title !== null
            ? output.Title
            : undefined,
        Url: output.Url !== undefined && output.Url !== null ? output.Url : undefined
    };
};
var deserializeAws_restJson1_1EmailChannelResponse = function (output, context) {
    return {
        __type: "EmailChannelResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        ConfigurationSet: output.ConfigurationSet !== undefined && output.ConfigurationSet !== null
            ? output.ConfigurationSet
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Enabled: output.Enabled !== undefined && output.Enabled !== null
            ? output.Enabled
            : undefined,
        FromAddress: output.FromAddress !== undefined && output.FromAddress !== null
            ? output.FromAddress
            : undefined,
        HasCredential: output.HasCredential !== undefined && output.HasCredential !== null
            ? output.HasCredential
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        Identity: output.Identity !== undefined && output.Identity !== null
            ? output.Identity
            : undefined,
        IsArchived: output.IsArchived !== undefined && output.IsArchived !== null
            ? output.IsArchived
            : undefined,
        LastModifiedBy: output.LastModifiedBy !== undefined && output.LastModifiedBy !== null
            ? output.LastModifiedBy
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        MessagesPerSecond: output.MessagesPerSecond !== undefined &&
            output.MessagesPerSecond !== null
            ? output.MessagesPerSecond
            : undefined,
        Platform: output.Platform !== undefined && output.Platform !== null
            ? output.Platform
            : undefined,
        RoleArn: output.RoleArn !== undefined && output.RoleArn !== null
            ? output.RoleArn
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1EmailMessageActivity = function (output, context) {
    return {
        __type: "EmailMessageActivity",
        MessageConfig: output.MessageConfig !== undefined && output.MessageConfig !== null
            ? deserializeAws_restJson1_1JourneyEmailMessage(output.MessageConfig, context)
            : undefined,
        NextActivity: output.NextActivity !== undefined && output.NextActivity !== null
            ? output.NextActivity
            : undefined,
        TemplateName: output.TemplateName !== undefined && output.TemplateName !== null
            ? output.TemplateName
            : undefined,
        TemplateVersion: output.TemplateVersion !== undefined && output.TemplateVersion !== null
            ? output.TemplateVersion
            : undefined
    };
};
var deserializeAws_restJson1_1EmailTemplateResponse = function (output, context) {
    return {
        __type: "EmailTemplateResponse",
        Arn: output.Arn !== undefined && output.Arn !== null ? output.Arn : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        DefaultSubstitutions: output.DefaultSubstitutions !== undefined &&
            output.DefaultSubstitutions !== null
            ? output.DefaultSubstitutions
            : undefined,
        HtmlPart: output.HtmlPart !== undefined && output.HtmlPart !== null
            ? output.HtmlPart
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Subject: output.Subject !== undefined && output.Subject !== null
            ? output.Subject
            : undefined,
        TemplateDescription: output.TemplateDescription !== undefined &&
            output.TemplateDescription !== null
            ? output.TemplateDescription
            : undefined,
        TemplateName: output.TemplateName !== undefined && output.TemplateName !== null
            ? output.TemplateName
            : undefined,
        TemplateType: output.TemplateType !== undefined && output.TemplateType !== null
            ? output.TemplateType
            : undefined,
        TextPart: output.TextPart !== undefined && output.TextPart !== null
            ? output.TextPart
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined,
        tags: output.tags !== undefined && output.tags !== null
            ? deserializeAws_restJson1_1MapOf__string(output.tags, context)
            : undefined
    };
};
var deserializeAws_restJson1_1EndpointDemographic = function (output, context) {
    return {
        __type: "EndpointDemographic",
        AppVersion: output.AppVersion !== undefined && output.AppVersion !== null
            ? output.AppVersion
            : undefined,
        Locale: output.Locale !== undefined && output.Locale !== null
            ? output.Locale
            : undefined,
        Make: output.Make !== undefined && output.Make !== null
            ? output.Make
            : undefined,
        Model: output.Model !== undefined && output.Model !== null
            ? output.Model
            : undefined,
        ModelVersion: output.ModelVersion !== undefined && output.ModelVersion !== null
            ? output.ModelVersion
            : undefined,
        Platform: output.Platform !== undefined && output.Platform !== null
            ? output.Platform
            : undefined,
        PlatformVersion: output.PlatformVersion !== undefined && output.PlatformVersion !== null
            ? output.PlatformVersion
            : undefined,
        Timezone: output.Timezone !== undefined && output.Timezone !== null
            ? output.Timezone
            : undefined
    };
};
var deserializeAws_restJson1_1EndpointItemResponse = function (output, context) {
    return {
        __type: "EndpointItemResponse",
        Message: output.Message !== undefined && output.Message !== null
            ? output.Message
            : undefined,
        StatusCode: output.StatusCode !== undefined && output.StatusCode !== null
            ? output.StatusCode
            : undefined
    };
};
var deserializeAws_restJson1_1EndpointLocation = function (output, context) {
    return {
        __type: "EndpointLocation",
        City: output.City !== undefined && output.City !== null
            ? output.City
            : undefined,
        Country: output.Country !== undefined && output.Country !== null
            ? output.Country
            : undefined,
        Latitude: output.Latitude !== undefined && output.Latitude !== null
            ? output.Latitude
            : undefined,
        Longitude: output.Longitude !== undefined && output.Longitude !== null
            ? output.Longitude
            : undefined,
        PostalCode: output.PostalCode !== undefined && output.PostalCode !== null
            ? output.PostalCode
            : undefined,
        Region: output.Region !== undefined && output.Region !== null
            ? output.Region
            : undefined
    };
};
var deserializeAws_restJson1_1EndpointMessageResult = function (output, context) {
    return {
        __type: "EndpointMessageResult",
        Address: output.Address !== undefined && output.Address !== null
            ? output.Address
            : undefined,
        DeliveryStatus: output.DeliveryStatus !== undefined && output.DeliveryStatus !== null
            ? output.DeliveryStatus
            : undefined,
        MessageId: output.MessageId !== undefined && output.MessageId !== null
            ? output.MessageId
            : undefined,
        StatusCode: output.StatusCode !== undefined && output.StatusCode !== null
            ? output.StatusCode
            : undefined,
        StatusMessage: output.StatusMessage !== undefined && output.StatusMessage !== null
            ? output.StatusMessage
            : undefined,
        UpdatedToken: output.UpdatedToken !== undefined && output.UpdatedToken !== null
            ? output.UpdatedToken
            : undefined
    };
};
var deserializeAws_restJson1_1EndpointResponse = function (output, context) {
    return {
        __type: "EndpointResponse",
        Address: output.Address !== undefined && output.Address !== null
            ? output.Address
            : undefined,
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        Attributes: output.Attributes !== undefined && output.Attributes !== null
            ? deserializeAws_restJson1_1MapOfListOf__string(output.Attributes, context)
            : undefined,
        ChannelType: output.ChannelType !== undefined && output.ChannelType !== null
            ? output.ChannelType
            : undefined,
        CohortId: output.CohortId !== undefined && output.CohortId !== null
            ? output.CohortId
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Demographic: output.Demographic !== undefined && output.Demographic !== null
            ? deserializeAws_restJson1_1EndpointDemographic(output.Demographic, context)
            : undefined,
        EffectiveDate: output.EffectiveDate !== undefined && output.EffectiveDate !== null
            ? output.EffectiveDate
            : undefined,
        EndpointStatus: output.EndpointStatus !== undefined && output.EndpointStatus !== null
            ? output.EndpointStatus
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        Location: output.Location !== undefined && output.Location !== null
            ? deserializeAws_restJson1_1EndpointLocation(output.Location, context)
            : undefined,
        Metrics: output.Metrics !== undefined && output.Metrics !== null
            ? deserializeAws_restJson1_1MapOf__double(output.Metrics, context)
            : undefined,
        OptOut: output.OptOut !== undefined && output.OptOut !== null
            ? output.OptOut
            : undefined,
        RequestId: output.RequestId !== undefined && output.RequestId !== null
            ? output.RequestId
            : undefined,
        User: output.User !== undefined && output.User !== null
            ? deserializeAws_restJson1_1EndpointUser(output.User, context)
            : undefined
    };
};
var deserializeAws_restJson1_1EndpointUser = function (output, context) {
    return {
        __type: "EndpointUser",
        UserAttributes: output.UserAttributes !== undefined && output.UserAttributes !== null
            ? deserializeAws_restJson1_1MapOfListOf__string(output.UserAttributes, context)
            : undefined,
        UserId: output.UserId !== undefined && output.UserId !== null
            ? output.UserId
            : undefined
    };
};
var deserializeAws_restJson1_1EndpointsResponse = function (output, context) {
    return {
        __type: "EndpointsResponse",
        Item: output.Item !== undefined && output.Item !== null
            ? deserializeAws_restJson1_1ListOfEndpointResponse(output.Item, context)
            : undefined
    };
};
var deserializeAws_restJson1_1EventCondition = function (output, context) {
    return {
        __type: "EventCondition",
        Dimensions: output.Dimensions !== undefined && output.Dimensions !== null
            ? deserializeAws_restJson1_1EventDimensions(output.Dimensions, context)
            : undefined,
        MessageActivity: output.MessageActivity !== undefined && output.MessageActivity !== null
            ? output.MessageActivity
            : undefined
    };
};
var deserializeAws_restJson1_1EventDimensions = function (output, context) {
    return {
        __type: "EventDimensions",
        Attributes: output.Attributes !== undefined && output.Attributes !== null
            ? deserializeAws_restJson1_1MapOfAttributeDimension(output.Attributes, context)
            : undefined,
        EventType: output.EventType !== undefined && output.EventType !== null
            ? deserializeAws_restJson1_1SetDimension(output.EventType, context)
            : undefined,
        Metrics: output.Metrics !== undefined && output.Metrics !== null
            ? deserializeAws_restJson1_1MapOfMetricDimension(output.Metrics, context)
            : undefined
    };
};
var deserializeAws_restJson1_1EventItemResponse = function (output, context) {
    return {
        __type: "EventItemResponse",
        Message: output.Message !== undefined && output.Message !== null
            ? output.Message
            : undefined,
        StatusCode: output.StatusCode !== undefined && output.StatusCode !== null
            ? output.StatusCode
            : undefined
    };
};
var deserializeAws_restJson1_1EventStream = function (output, context) {
    return {
        __type: "EventStream",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        DestinationStreamArn: output.DestinationStreamArn !== undefined &&
            output.DestinationStreamArn !== null
            ? output.DestinationStreamArn
            : undefined,
        ExternalId: output.ExternalId !== undefined && output.ExternalId !== null
            ? output.ExternalId
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        LastUpdatedBy: output.LastUpdatedBy !== undefined && output.LastUpdatedBy !== null
            ? output.LastUpdatedBy
            : undefined,
        RoleArn: output.RoleArn !== undefined && output.RoleArn !== null
            ? output.RoleArn
            : undefined
    };
};
var deserializeAws_restJson1_1EventsResponse = function (output, context) {
    return {
        __type: "EventsResponse",
        Results: output.Results !== undefined && output.Results !== null
            ? deserializeAws_restJson1_1MapOfItemResponse(output.Results, context)
            : undefined
    };
};
var deserializeAws_restJson1_1ExportJobResource = function (output, context) {
    return {
        __type: "ExportJobResource",
        RoleArn: output.RoleArn !== undefined && output.RoleArn !== null
            ? output.RoleArn
            : undefined,
        S3UrlPrefix: output.S3UrlPrefix !== undefined && output.S3UrlPrefix !== null
            ? output.S3UrlPrefix
            : undefined,
        SegmentId: output.SegmentId !== undefined && output.SegmentId !== null
            ? output.SegmentId
            : undefined,
        SegmentVersion: output.SegmentVersion !== undefined && output.SegmentVersion !== null
            ? output.SegmentVersion
            : undefined
    };
};
var deserializeAws_restJson1_1ExportJobResponse = function (output, context) {
    return {
        __type: "ExportJobResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CompletedPieces: output.CompletedPieces !== undefined && output.CompletedPieces !== null
            ? output.CompletedPieces
            : undefined,
        CompletionDate: output.CompletionDate !== undefined && output.CompletionDate !== null
            ? output.CompletionDate
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Definition: output.Definition !== undefined && output.Definition !== null
            ? deserializeAws_restJson1_1ExportJobResource(output.Definition, context)
            : undefined,
        FailedPieces: output.FailedPieces !== undefined && output.FailedPieces !== null
            ? output.FailedPieces
            : undefined,
        Failures: output.Failures !== undefined && output.Failures !== null
            ? deserializeAws_restJson1_1ListOf__string(output.Failures, context)
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        JobStatus: output.JobStatus !== undefined && output.JobStatus !== null
            ? output.JobStatus
            : undefined,
        TotalFailures: output.TotalFailures !== undefined && output.TotalFailures !== null
            ? output.TotalFailures
            : undefined,
        TotalPieces: output.TotalPieces !== undefined && output.TotalPieces !== null
            ? output.TotalPieces
            : undefined,
        TotalProcessed: output.TotalProcessed !== undefined && output.TotalProcessed !== null
            ? output.TotalProcessed
            : undefined,
        Type: output.Type !== undefined && output.Type !== null
            ? output.Type
            : undefined
    };
};
var deserializeAws_restJson1_1ExportJobsResponse = function (output, context) {
    return {
        __type: "ExportJobsResponse",
        Item: output.Item !== undefined && output.Item !== null
            ? deserializeAws_restJson1_1ListOfExportJobResponse(output.Item, context)
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null
            ? output.NextToken
            : undefined
    };
};
var deserializeAws_restJson1_1GCMChannelResponse = function (output, context) {
    return {
        __type: "GCMChannelResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Credential: output.Credential !== undefined && output.Credential !== null
            ? output.Credential
            : undefined,
        Enabled: output.Enabled !== undefined && output.Enabled !== null
            ? output.Enabled
            : undefined,
        HasCredential: output.HasCredential !== undefined && output.HasCredential !== null
            ? output.HasCredential
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        IsArchived: output.IsArchived !== undefined && output.IsArchived !== null
            ? output.IsArchived
            : undefined,
        LastModifiedBy: output.LastModifiedBy !== undefined && output.LastModifiedBy !== null
            ? output.LastModifiedBy
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Platform: output.Platform !== undefined && output.Platform !== null
            ? output.Platform
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1GPSCoordinates = function (output, context) {
    return {
        __type: "GPSCoordinates",
        Latitude: output.Latitude !== undefined && output.Latitude !== null
            ? output.Latitude
            : undefined,
        Longitude: output.Longitude !== undefined && output.Longitude !== null
            ? output.Longitude
            : undefined
    };
};
var deserializeAws_restJson1_1GPSPointDimension = function (output, context) {
    return {
        __type: "GPSPointDimension",
        Coordinates: output.Coordinates !== undefined && output.Coordinates !== null
            ? deserializeAws_restJson1_1GPSCoordinates(output.Coordinates, context)
            : undefined,
        RangeInKilometers: output.RangeInKilometers !== undefined &&
            output.RangeInKilometers !== null
            ? output.RangeInKilometers
            : undefined
    };
};
var deserializeAws_restJson1_1HoldoutActivity = function (output, context) {
    return {
        __type: "HoldoutActivity",
        NextActivity: output.NextActivity !== undefined && output.NextActivity !== null
            ? output.NextActivity
            : undefined,
        Percentage: output.Percentage !== undefined && output.Percentage !== null
            ? output.Percentage
            : undefined
    };
};
var deserializeAws_restJson1_1ImportJobResource = function (output, context) {
    return {
        __type: "ImportJobResource",
        DefineSegment: output.DefineSegment !== undefined && output.DefineSegment !== null
            ? output.DefineSegment
            : undefined,
        ExternalId: output.ExternalId !== undefined && output.ExternalId !== null
            ? output.ExternalId
            : undefined,
        Format: output.Format !== undefined && output.Format !== null
            ? output.Format
            : undefined,
        RegisterEndpoints: output.RegisterEndpoints !== undefined &&
            output.RegisterEndpoints !== null
            ? output.RegisterEndpoints
            : undefined,
        RoleArn: output.RoleArn !== undefined && output.RoleArn !== null
            ? output.RoleArn
            : undefined,
        S3Url: output.S3Url !== undefined && output.S3Url !== null
            ? output.S3Url
            : undefined,
        SegmentId: output.SegmentId !== undefined && output.SegmentId !== null
            ? output.SegmentId
            : undefined,
        SegmentName: output.SegmentName !== undefined && output.SegmentName !== null
            ? output.SegmentName
            : undefined
    };
};
var deserializeAws_restJson1_1ImportJobResponse = function (output, context) {
    return {
        __type: "ImportJobResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CompletedPieces: output.CompletedPieces !== undefined && output.CompletedPieces !== null
            ? output.CompletedPieces
            : undefined,
        CompletionDate: output.CompletionDate !== undefined && output.CompletionDate !== null
            ? output.CompletionDate
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Definition: output.Definition !== undefined && output.Definition !== null
            ? deserializeAws_restJson1_1ImportJobResource(output.Definition, context)
            : undefined,
        FailedPieces: output.FailedPieces !== undefined && output.FailedPieces !== null
            ? output.FailedPieces
            : undefined,
        Failures: output.Failures !== undefined && output.Failures !== null
            ? deserializeAws_restJson1_1ListOf__string(output.Failures, context)
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        JobStatus: output.JobStatus !== undefined && output.JobStatus !== null
            ? output.JobStatus
            : undefined,
        TotalFailures: output.TotalFailures !== undefined && output.TotalFailures !== null
            ? output.TotalFailures
            : undefined,
        TotalPieces: output.TotalPieces !== undefined && output.TotalPieces !== null
            ? output.TotalPieces
            : undefined,
        TotalProcessed: output.TotalProcessed !== undefined && output.TotalProcessed !== null
            ? output.TotalProcessed
            : undefined,
        Type: output.Type !== undefined && output.Type !== null
            ? output.Type
            : undefined
    };
};
var deserializeAws_restJson1_1ImportJobsResponse = function (output, context) {
    return {
        __type: "ImportJobsResponse",
        Item: output.Item !== undefined && output.Item !== null
            ? deserializeAws_restJson1_1ListOfImportJobResponse(output.Item, context)
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null
            ? output.NextToken
            : undefined
    };
};
var deserializeAws_restJson1_1ItemResponse = function (output, context) {
    return {
        __type: "ItemResponse",
        EndpointItemResponse: output.EndpointItemResponse !== undefined &&
            output.EndpointItemResponse !== null
            ? deserializeAws_restJson1_1EndpointItemResponse(output.EndpointItemResponse, context)
            : undefined,
        EventsItemResponse: output.EventsItemResponse !== undefined &&
            output.EventsItemResponse !== null
            ? deserializeAws_restJson1_1MapOfEventItemResponse(output.EventsItemResponse, context)
            : undefined
    };
};
var deserializeAws_restJson1_1JourneyDateRangeKpiResponse = function (output, context) {
    return {
        __type: "JourneyDateRangeKpiResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        EndTime: output.EndTime !== undefined && output.EndTime !== null
            ? new Date(output.EndTime)
            : undefined,
        JourneyId: output.JourneyId !== undefined && output.JourneyId !== null
            ? output.JourneyId
            : undefined,
        KpiName: output.KpiName !== undefined && output.KpiName !== null
            ? output.KpiName
            : undefined,
        KpiResult: output.KpiResult !== undefined && output.KpiResult !== null
            ? deserializeAws_restJson1_1BaseKpiResult(output.KpiResult, context)
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null
            ? output.NextToken
            : undefined,
        StartTime: output.StartTime !== undefined && output.StartTime !== null
            ? new Date(output.StartTime)
            : undefined
    };
};
var deserializeAws_restJson1_1JourneyEmailMessage = function (output, context) {
    return {
        __type: "JourneyEmailMessage",
        FromAddress: output.FromAddress !== undefined && output.FromAddress !== null
            ? output.FromAddress
            : undefined
    };
};
var deserializeAws_restJson1_1JourneyExecutionActivityMetricsResponse = function (output, context) {
    return {
        __type: "JourneyExecutionActivityMetricsResponse",
        ActivityType: output.ActivityType !== undefined && output.ActivityType !== null
            ? output.ActivityType
            : undefined,
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        JourneyActivityId: output.JourneyActivityId !== undefined &&
            output.JourneyActivityId !== null
            ? output.JourneyActivityId
            : undefined,
        JourneyId: output.JourneyId !== undefined && output.JourneyId !== null
            ? output.JourneyId
            : undefined,
        LastEvaluatedTime: output.LastEvaluatedTime !== undefined &&
            output.LastEvaluatedTime !== null
            ? output.LastEvaluatedTime
            : undefined,
        Metrics: output.Metrics !== undefined && output.Metrics !== null
            ? deserializeAws_restJson1_1MapOf__string(output.Metrics, context)
            : undefined
    };
};
var deserializeAws_restJson1_1JourneyExecutionMetricsResponse = function (output, context) {
    return {
        __type: "JourneyExecutionMetricsResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        JourneyId: output.JourneyId !== undefined && output.JourneyId !== null
            ? output.JourneyId
            : undefined,
        LastEvaluatedTime: output.LastEvaluatedTime !== undefined &&
            output.LastEvaluatedTime !== null
            ? output.LastEvaluatedTime
            : undefined,
        Metrics: output.Metrics !== undefined && output.Metrics !== null
            ? deserializeAws_restJson1_1MapOf__string(output.Metrics, context)
            : undefined
    };
};
var deserializeAws_restJson1_1JourneyLimits = function (output, context) {
    return {
        __type: "JourneyLimits",
        DailyCap: output.DailyCap !== undefined && output.DailyCap !== null
            ? output.DailyCap
            : undefined,
        EndpointReentryCap: output.EndpointReentryCap !== undefined &&
            output.EndpointReentryCap !== null
            ? output.EndpointReentryCap
            : undefined,
        MessagesPerSecond: output.MessagesPerSecond !== undefined &&
            output.MessagesPerSecond !== null
            ? output.MessagesPerSecond
            : undefined
    };
};
var deserializeAws_restJson1_1JourneyResponse = function (output, context) {
    return {
        __type: "JourneyResponse",
        Activities: output.Activities !== undefined && output.Activities !== null
            ? deserializeAws_restJson1_1MapOfActivity(output.Activities, context)
            : undefined,
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Limits: output.Limits !== undefined && output.Limits !== null
            ? deserializeAws_restJson1_1JourneyLimits(output.Limits, context)
            : undefined,
        LocalTime: output.LocalTime !== undefined && output.LocalTime !== null
            ? output.LocalTime
            : undefined,
        Name: output.Name !== undefined && output.Name !== null
            ? output.Name
            : undefined,
        QuietTime: output.QuietTime !== undefined && output.QuietTime !== null
            ? deserializeAws_restJson1_1QuietTime(output.QuietTime, context)
            : undefined,
        RefreshFrequency: output.RefreshFrequency !== undefined && output.RefreshFrequency !== null
            ? output.RefreshFrequency
            : undefined,
        Schedule: output.Schedule !== undefined && output.Schedule !== null
            ? deserializeAws_restJson1_1JourneySchedule(output.Schedule, context)
            : undefined,
        StartActivity: output.StartActivity !== undefined && output.StartActivity !== null
            ? output.StartActivity
            : undefined,
        StartCondition: output.StartCondition !== undefined && output.StartCondition !== null
            ? deserializeAws_restJson1_1StartCondition(output.StartCondition, context)
            : undefined,
        State: output.State !== undefined && output.State !== null
            ? output.State
            : undefined,
        tags: output.tags !== undefined && output.tags !== null
            ? deserializeAws_restJson1_1MapOf__string(output.tags, context)
            : undefined
    };
};
var deserializeAws_restJson1_1JourneySchedule = function (output, context) {
    return {
        __type: "JourneySchedule",
        EndTime: output.EndTime !== undefined && output.EndTime !== null
            ? new Date(output.EndTime)
            : undefined,
        StartTime: output.StartTime !== undefined && output.StartTime !== null
            ? new Date(output.StartTime)
            : undefined,
        Timezone: output.Timezone !== undefined && output.Timezone !== null
            ? output.Timezone
            : undefined
    };
};
var deserializeAws_restJson1_1JourneysResponse = function (output, context) {
    return {
        __type: "JourneysResponse",
        Item: output.Item !== undefined && output.Item !== null
            ? deserializeAws_restJson1_1ListOfJourneyResponse(output.Item, context)
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null
            ? output.NextToken
            : undefined
    };
};
var deserializeAws_restJson1_1ListOfActivityResponse = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1ActivityResponse(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfApplicationResponse = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1ApplicationResponse(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfCampaignResponse = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1CampaignResponse(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfEndpointResponse = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1EndpointResponse(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfExportJobResponse = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1ExportJobResponse(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfImportJobResponse = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1ImportJobResponse(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfJourneyResponse = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1JourneyResponse(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfMultiConditionalBranch = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1MultiConditionalBranch(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfRandomSplitEntry = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1RandomSplitEntry(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfResultRow = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1ResultRow(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfResultRowValue = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1ResultRowValue(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfSegmentDimensions = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1SegmentDimensions(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfSegmentGroup = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1SegmentGroup(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfSegmentReference = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1SegmentReference(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfSegmentResponse = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1SegmentResponse(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfSimpleCondition = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1SimpleCondition(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfTemplateResponse = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1TemplateResponse(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfTemplateVersionResponse = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1TemplateVersionResponse(entry, context);
    });
};
var deserializeAws_restJson1_1ListOfTreatmentResource = function (output, context) {
    return (output || []).map(function (entry) {
        return deserializeAws_restJson1_1TreatmentResource(entry, context);
    });
};
var deserializeAws_restJson1_1ListOf__string = function (output, context) {
    return (output || []).map(function (entry) { return entry; });
};
var deserializeAws_restJson1_1MapOfActivity = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1_1Activity(value, context), _b)));
    }, {});
};
var deserializeAws_restJson1_1MapOfAttributeDimension = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1_1AttributeDimension(value, context), _b)));
    }, {});
};
var deserializeAws_restJson1_1MapOfChannelResponse = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1_1ChannelResponse(value, context), _b)));
    }, {});
};
var deserializeAws_restJson1_1MapOfEndpointMessageResult = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1_1EndpointMessageResult(value, context), _b)));
    }, {});
};
var deserializeAws_restJson1_1MapOfEventItemResponse = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1_1EventItemResponse(value, context), _b)));
    }, {});
};
var deserializeAws_restJson1_1MapOfItemResponse = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1_1ItemResponse(value, context), _b)));
    }, {});
};
var deserializeAws_restJson1_1MapOfListOf__string = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1_1ListOf__string(value, context), _b)));
    }, {});
};
var deserializeAws_restJson1_1MapOfMapOfEndpointMessageResult = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1_1MapOfEndpointMessageResult(value, context), _b)));
    }, {});
};
var deserializeAws_restJson1_1MapOfMessageResult = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1_1MessageResult(value, context), _b)));
    }, {});
};
var deserializeAws_restJson1_1MapOfMetricDimension = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1_1MetricDimension(value, context), _b)));
    }, {});
};
var deserializeAws_restJson1_1MapOf__double = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
    }, {});
};
var deserializeAws_restJson1_1MapOf__integer = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
    }, {});
};
var deserializeAws_restJson1_1MapOf__string = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
    }, {});
};
var deserializeAws_restJson1_1Message = function (output, context) {
    return {
        __type: "Message",
        Action: output.Action !== undefined && output.Action !== null
            ? output.Action
            : undefined,
        Body: output.Body !== undefined && output.Body !== null
            ? output.Body
            : undefined,
        ImageIconUrl: output.ImageIconUrl !== undefined && output.ImageIconUrl !== null
            ? output.ImageIconUrl
            : undefined,
        ImageSmallIconUrl: output.ImageSmallIconUrl !== undefined &&
            output.ImageSmallIconUrl !== null
            ? output.ImageSmallIconUrl
            : undefined,
        ImageUrl: output.ImageUrl !== undefined && output.ImageUrl !== null
            ? output.ImageUrl
            : undefined,
        JsonBody: output.JsonBody !== undefined && output.JsonBody !== null
            ? output.JsonBody
            : undefined,
        MediaUrl: output.MediaUrl !== undefined && output.MediaUrl !== null
            ? output.MediaUrl
            : undefined,
        RawContent: output.RawContent !== undefined && output.RawContent !== null
            ? output.RawContent
            : undefined,
        SilentPush: output.SilentPush !== undefined && output.SilentPush !== null
            ? output.SilentPush
            : undefined,
        TimeToLive: output.TimeToLive !== undefined && output.TimeToLive !== null
            ? output.TimeToLive
            : undefined,
        Title: output.Title !== undefined && output.Title !== null
            ? output.Title
            : undefined,
        Url: output.Url !== undefined && output.Url !== null ? output.Url : undefined
    };
};
var deserializeAws_restJson1_1MessageBody = function (output, context) {
    return {
        __type: "MessageBody",
        Message: output.Message !== undefined && output.Message !== null
            ? output.Message
            : undefined,
        RequestID: output.RequestID !== undefined && output.RequestID !== null
            ? output.RequestID
            : undefined
    };
};
var deserializeAws_restJson1_1MessageConfiguration = function (output, context) {
    return {
        __type: "MessageConfiguration",
        ADMMessage: output.ADMMessage !== undefined && output.ADMMessage !== null
            ? deserializeAws_restJson1_1Message(output.ADMMessage, context)
            : undefined,
        APNSMessage: output.APNSMessage !== undefined && output.APNSMessage !== null
            ? deserializeAws_restJson1_1Message(output.APNSMessage, context)
            : undefined,
        BaiduMessage: output.BaiduMessage !== undefined && output.BaiduMessage !== null
            ? deserializeAws_restJson1_1Message(output.BaiduMessage, context)
            : undefined,
        DefaultMessage: output.DefaultMessage !== undefined && output.DefaultMessage !== null
            ? deserializeAws_restJson1_1Message(output.DefaultMessage, context)
            : undefined,
        EmailMessage: output.EmailMessage !== undefined && output.EmailMessage !== null
            ? deserializeAws_restJson1_1CampaignEmailMessage(output.EmailMessage, context)
            : undefined,
        GCMMessage: output.GCMMessage !== undefined && output.GCMMessage !== null
            ? deserializeAws_restJson1_1Message(output.GCMMessage, context)
            : undefined,
        SMSMessage: output.SMSMessage !== undefined && output.SMSMessage !== null
            ? deserializeAws_restJson1_1CampaignSmsMessage(output.SMSMessage, context)
            : undefined
    };
};
var deserializeAws_restJson1_1MessageResponse = function (output, context) {
    return {
        __type: "MessageResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        EndpointResult: output.EndpointResult !== undefined && output.EndpointResult !== null
            ? deserializeAws_restJson1_1MapOfEndpointMessageResult(output.EndpointResult, context)
            : undefined,
        RequestId: output.RequestId !== undefined && output.RequestId !== null
            ? output.RequestId
            : undefined,
        Result: output.Result !== undefined && output.Result !== null
            ? deserializeAws_restJson1_1MapOfMessageResult(output.Result, context)
            : undefined
    };
};
var deserializeAws_restJson1_1MessageResult = function (output, context) {
    return {
        __type: "MessageResult",
        DeliveryStatus: output.DeliveryStatus !== undefined && output.DeliveryStatus !== null
            ? output.DeliveryStatus
            : undefined,
        MessageId: output.MessageId !== undefined && output.MessageId !== null
            ? output.MessageId
            : undefined,
        StatusCode: output.StatusCode !== undefined && output.StatusCode !== null
            ? output.StatusCode
            : undefined,
        StatusMessage: output.StatusMessage !== undefined && output.StatusMessage !== null
            ? output.StatusMessage
            : undefined,
        UpdatedToken: output.UpdatedToken !== undefined && output.UpdatedToken !== null
            ? output.UpdatedToken
            : undefined
    };
};
var deserializeAws_restJson1_1MetricDimension = function (output, context) {
    return {
        __type: "MetricDimension",
        ComparisonOperator: output.ComparisonOperator !== undefined &&
            output.ComparisonOperator !== null
            ? output.ComparisonOperator
            : undefined,
        Value: output.Value !== undefined && output.Value !== null
            ? output.Value
            : undefined
    };
};
var deserializeAws_restJson1_1MultiConditionalBranch = function (output, context) {
    return {
        __type: "MultiConditionalBranch",
        Condition: output.Condition !== undefined && output.Condition !== null
            ? deserializeAws_restJson1_1SimpleCondition(output.Condition, context)
            : undefined,
        NextActivity: output.NextActivity !== undefined && output.NextActivity !== null
            ? output.NextActivity
            : undefined
    };
};
var deserializeAws_restJson1_1MultiConditionalSplitActivity = function (output, context) {
    return {
        __type: "MultiConditionalSplitActivity",
        Branches: output.Branches !== undefined && output.Branches !== null
            ? deserializeAws_restJson1_1ListOfMultiConditionalBranch(output.Branches, context)
            : undefined,
        DefaultActivity: output.DefaultActivity !== undefined && output.DefaultActivity !== null
            ? output.DefaultActivity
            : undefined,
        EvaluationWaitTime: output.EvaluationWaitTime !== undefined &&
            output.EvaluationWaitTime !== null
            ? deserializeAws_restJson1_1WaitTime(output.EvaluationWaitTime, context)
            : undefined
    };
};
var deserializeAws_restJson1_1NumberValidateResponse = function (output, context) {
    return {
        __type: "NumberValidateResponse",
        Carrier: output.Carrier !== undefined && output.Carrier !== null
            ? output.Carrier
            : undefined,
        City: output.City !== undefined && output.City !== null
            ? output.City
            : undefined,
        CleansedPhoneNumberE164: output.CleansedPhoneNumberE164 !== undefined &&
            output.CleansedPhoneNumberE164 !== null
            ? output.CleansedPhoneNumberE164
            : undefined,
        CleansedPhoneNumberNational: output.CleansedPhoneNumberNational !== undefined &&
            output.CleansedPhoneNumberNational !== null
            ? output.CleansedPhoneNumberNational
            : undefined,
        Country: output.Country !== undefined && output.Country !== null
            ? output.Country
            : undefined,
        CountryCodeIso2: output.CountryCodeIso2 !== undefined && output.CountryCodeIso2 !== null
            ? output.CountryCodeIso2
            : undefined,
        CountryCodeNumeric: output.CountryCodeNumeric !== undefined &&
            output.CountryCodeNumeric !== null
            ? output.CountryCodeNumeric
            : undefined,
        County: output.County !== undefined && output.County !== null
            ? output.County
            : undefined,
        OriginalCountryCodeIso2: output.OriginalCountryCodeIso2 !== undefined &&
            output.OriginalCountryCodeIso2 !== null
            ? output.OriginalCountryCodeIso2
            : undefined,
        OriginalPhoneNumber: output.OriginalPhoneNumber !== undefined &&
            output.OriginalPhoneNumber !== null
            ? output.OriginalPhoneNumber
            : undefined,
        PhoneType: output.PhoneType !== undefined && output.PhoneType !== null
            ? output.PhoneType
            : undefined,
        PhoneTypeCode: output.PhoneTypeCode !== undefined && output.PhoneTypeCode !== null
            ? output.PhoneTypeCode
            : undefined,
        Timezone: output.Timezone !== undefined && output.Timezone !== null
            ? output.Timezone
            : undefined,
        ZipCode: output.ZipCode !== undefined && output.ZipCode !== null
            ? output.ZipCode
            : undefined
    };
};
var deserializeAws_restJson1_1PushNotificationTemplateResponse = function (output, context) {
    return {
        __type: "PushNotificationTemplateResponse",
        ADM: output.ADM !== undefined && output.ADM !== null
            ? deserializeAws_restJson1_1AndroidPushNotificationTemplate(output.ADM, context)
            : undefined,
        APNS: output.APNS !== undefined && output.APNS !== null
            ? deserializeAws_restJson1_1APNSPushNotificationTemplate(output.APNS, context)
            : undefined,
        Arn: output.Arn !== undefined && output.Arn !== null ? output.Arn : undefined,
        Baidu: output.Baidu !== undefined && output.Baidu !== null
            ? deserializeAws_restJson1_1AndroidPushNotificationTemplate(output.Baidu, context)
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Default: output.Default !== undefined && output.Default !== null
            ? deserializeAws_restJson1_1DefaultPushNotificationTemplate(output.Default, context)
            : undefined,
        DefaultSubstitutions: output.DefaultSubstitutions !== undefined &&
            output.DefaultSubstitutions !== null
            ? output.DefaultSubstitutions
            : undefined,
        GCM: output.GCM !== undefined && output.GCM !== null
            ? deserializeAws_restJson1_1AndroidPushNotificationTemplate(output.GCM, context)
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        TemplateDescription: output.TemplateDescription !== undefined &&
            output.TemplateDescription !== null
            ? output.TemplateDescription
            : undefined,
        TemplateName: output.TemplateName !== undefined && output.TemplateName !== null
            ? output.TemplateName
            : undefined,
        TemplateType: output.TemplateType !== undefined && output.TemplateType !== null
            ? output.TemplateType
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined,
        tags: output.tags !== undefined && output.tags !== null
            ? deserializeAws_restJson1_1MapOf__string(output.tags, context)
            : undefined
    };
};
var deserializeAws_restJson1_1QuietTime = function (output, context) {
    return {
        __type: "QuietTime",
        End: output.End !== undefined && output.End !== null ? output.End : undefined,
        Start: output.Start !== undefined && output.Start !== null
            ? output.Start
            : undefined
    };
};
var deserializeAws_restJson1_1RandomSplitActivity = function (output, context) {
    return {
        __type: "RandomSplitActivity",
        Branches: output.Branches !== undefined && output.Branches !== null
            ? deserializeAws_restJson1_1ListOfRandomSplitEntry(output.Branches, context)
            : undefined
    };
};
var deserializeAws_restJson1_1RandomSplitEntry = function (output, context) {
    return {
        __type: "RandomSplitEntry",
        NextActivity: output.NextActivity !== undefined && output.NextActivity !== null
            ? output.NextActivity
            : undefined,
        Percentage: output.Percentage !== undefined && output.Percentage !== null
            ? output.Percentage
            : undefined
    };
};
var deserializeAws_restJson1_1RecencyDimension = function (output, context) {
    return {
        __type: "RecencyDimension",
        Duration: output.Duration !== undefined && output.Duration !== null
            ? output.Duration
            : undefined,
        RecencyType: output.RecencyType !== undefined && output.RecencyType !== null
            ? output.RecencyType
            : undefined
    };
};
var deserializeAws_restJson1_1ResultRow = function (output, context) {
    return {
        __type: "ResultRow",
        GroupedBys: output.GroupedBys !== undefined && output.GroupedBys !== null
            ? deserializeAws_restJson1_1ListOfResultRowValue(output.GroupedBys, context)
            : undefined,
        Values: output.Values !== undefined && output.Values !== null
            ? deserializeAws_restJson1_1ListOfResultRowValue(output.Values, context)
            : undefined
    };
};
var deserializeAws_restJson1_1ResultRowValue = function (output, context) {
    return {
        __type: "ResultRowValue",
        Key: output.Key !== undefined && output.Key !== null ? output.Key : undefined,
        Type: output.Type !== undefined && output.Type !== null
            ? output.Type
            : undefined,
        Value: output.Value !== undefined && output.Value !== null
            ? output.Value
            : undefined
    };
};
var deserializeAws_restJson1_1SMSChannelResponse = function (output, context) {
    return {
        __type: "SMSChannelResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Enabled: output.Enabled !== undefined && output.Enabled !== null
            ? output.Enabled
            : undefined,
        HasCredential: output.HasCredential !== undefined && output.HasCredential !== null
            ? output.HasCredential
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        IsArchived: output.IsArchived !== undefined && output.IsArchived !== null
            ? output.IsArchived
            : undefined,
        LastModifiedBy: output.LastModifiedBy !== undefined && output.LastModifiedBy !== null
            ? output.LastModifiedBy
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Platform: output.Platform !== undefined && output.Platform !== null
            ? output.Platform
            : undefined,
        PromotionalMessagesPerSecond: output.PromotionalMessagesPerSecond !== undefined &&
            output.PromotionalMessagesPerSecond !== null
            ? output.PromotionalMessagesPerSecond
            : undefined,
        SenderId: output.SenderId !== undefined && output.SenderId !== null
            ? output.SenderId
            : undefined,
        ShortCode: output.ShortCode !== undefined && output.ShortCode !== null
            ? output.ShortCode
            : undefined,
        TransactionalMessagesPerSecond: output.TransactionalMessagesPerSecond !== undefined &&
            output.TransactionalMessagesPerSecond !== null
            ? output.TransactionalMessagesPerSecond
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1SMSTemplateResponse = function (output, context) {
    return {
        __type: "SMSTemplateResponse",
        Arn: output.Arn !== undefined && output.Arn !== null ? output.Arn : undefined,
        Body: output.Body !== undefined && output.Body !== null
            ? output.Body
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        DefaultSubstitutions: output.DefaultSubstitutions !== undefined &&
            output.DefaultSubstitutions !== null
            ? output.DefaultSubstitutions
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        TemplateDescription: output.TemplateDescription !== undefined &&
            output.TemplateDescription !== null
            ? output.TemplateDescription
            : undefined,
        TemplateName: output.TemplateName !== undefined && output.TemplateName !== null
            ? output.TemplateName
            : undefined,
        TemplateType: output.TemplateType !== undefined && output.TemplateType !== null
            ? output.TemplateType
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined,
        tags: output.tags !== undefined && output.tags !== null
            ? deserializeAws_restJson1_1MapOf__string(output.tags, context)
            : undefined
    };
};
var deserializeAws_restJson1_1Schedule = function (output, context) {
    return {
        __type: "Schedule",
        EndTime: output.EndTime !== undefined && output.EndTime !== null
            ? output.EndTime
            : undefined,
        EventFilter: output.EventFilter !== undefined && output.EventFilter !== null
            ? deserializeAws_restJson1_1CampaignEventFilter(output.EventFilter, context)
            : undefined,
        Frequency: output.Frequency !== undefined && output.Frequency !== null
            ? output.Frequency
            : undefined,
        IsLocalTime: output.IsLocalTime !== undefined && output.IsLocalTime !== null
            ? output.IsLocalTime
            : undefined,
        QuietTime: output.QuietTime !== undefined && output.QuietTime !== null
            ? deserializeAws_restJson1_1QuietTime(output.QuietTime, context)
            : undefined,
        StartTime: output.StartTime !== undefined && output.StartTime !== null
            ? output.StartTime
            : undefined,
        Timezone: output.Timezone !== undefined && output.Timezone !== null
            ? output.Timezone
            : undefined
    };
};
var deserializeAws_restJson1_1SegmentBehaviors = function (output, context) {
    return {
        __type: "SegmentBehaviors",
        Recency: output.Recency !== undefined && output.Recency !== null
            ? deserializeAws_restJson1_1RecencyDimension(output.Recency, context)
            : undefined
    };
};
var deserializeAws_restJson1_1SegmentCondition = function (output, context) {
    return {
        __type: "SegmentCondition",
        SegmentId: output.SegmentId !== undefined && output.SegmentId !== null
            ? output.SegmentId
            : undefined
    };
};
var deserializeAws_restJson1_1SegmentDemographics = function (output, context) {
    return {
        __type: "SegmentDemographics",
        AppVersion: output.AppVersion !== undefined && output.AppVersion !== null
            ? deserializeAws_restJson1_1SetDimension(output.AppVersion, context)
            : undefined,
        Channel: output.Channel !== undefined && output.Channel !== null
            ? deserializeAws_restJson1_1SetDimension(output.Channel, context)
            : undefined,
        DeviceType: output.DeviceType !== undefined && output.DeviceType !== null
            ? deserializeAws_restJson1_1SetDimension(output.DeviceType, context)
            : undefined,
        Make: output.Make !== undefined && output.Make !== null
            ? deserializeAws_restJson1_1SetDimension(output.Make, context)
            : undefined,
        Model: output.Model !== undefined && output.Model !== null
            ? deserializeAws_restJson1_1SetDimension(output.Model, context)
            : undefined,
        Platform: output.Platform !== undefined && output.Platform !== null
            ? deserializeAws_restJson1_1SetDimension(output.Platform, context)
            : undefined
    };
};
var deserializeAws_restJson1_1SegmentDimensions = function (output, context) {
    return {
        __type: "SegmentDimensions",
        Attributes: output.Attributes !== undefined && output.Attributes !== null
            ? deserializeAws_restJson1_1MapOfAttributeDimension(output.Attributes, context)
            : undefined,
        Behavior: output.Behavior !== undefined && output.Behavior !== null
            ? deserializeAws_restJson1_1SegmentBehaviors(output.Behavior, context)
            : undefined,
        Demographic: output.Demographic !== undefined && output.Demographic !== null
            ? deserializeAws_restJson1_1SegmentDemographics(output.Demographic, context)
            : undefined,
        Location: output.Location !== undefined && output.Location !== null
            ? deserializeAws_restJson1_1SegmentLocation(output.Location, context)
            : undefined,
        Metrics: output.Metrics !== undefined && output.Metrics !== null
            ? deserializeAws_restJson1_1MapOfMetricDimension(output.Metrics, context)
            : undefined,
        UserAttributes: output.UserAttributes !== undefined && output.UserAttributes !== null
            ? deserializeAws_restJson1_1MapOfAttributeDimension(output.UserAttributes, context)
            : undefined
    };
};
var deserializeAws_restJson1_1SegmentGroup = function (output, context) {
    return {
        __type: "SegmentGroup",
        Dimensions: output.Dimensions !== undefined && output.Dimensions !== null
            ? deserializeAws_restJson1_1ListOfSegmentDimensions(output.Dimensions, context)
            : undefined,
        SourceSegments: output.SourceSegments !== undefined && output.SourceSegments !== null
            ? deserializeAws_restJson1_1ListOfSegmentReference(output.SourceSegments, context)
            : undefined,
        SourceType: output.SourceType !== undefined && output.SourceType !== null
            ? output.SourceType
            : undefined,
        Type: output.Type !== undefined && output.Type !== null
            ? output.Type
            : undefined
    };
};
var deserializeAws_restJson1_1SegmentGroupList = function (output, context) {
    return {
        __type: "SegmentGroupList",
        Groups: output.Groups !== undefined && output.Groups !== null
            ? deserializeAws_restJson1_1ListOfSegmentGroup(output.Groups, context)
            : undefined,
        Include: output.Include !== undefined && output.Include !== null
            ? output.Include
            : undefined
    };
};
var deserializeAws_restJson1_1SegmentImportResource = function (output, context) {
    return {
        __type: "SegmentImportResource",
        ChannelCounts: output.ChannelCounts !== undefined && output.ChannelCounts !== null
            ? deserializeAws_restJson1_1MapOf__integer(output.ChannelCounts, context)
            : undefined,
        ExternalId: output.ExternalId !== undefined && output.ExternalId !== null
            ? output.ExternalId
            : undefined,
        Format: output.Format !== undefined && output.Format !== null
            ? output.Format
            : undefined,
        RoleArn: output.RoleArn !== undefined && output.RoleArn !== null
            ? output.RoleArn
            : undefined,
        S3Url: output.S3Url !== undefined && output.S3Url !== null
            ? output.S3Url
            : undefined,
        Size: output.Size !== undefined && output.Size !== null
            ? output.Size
            : undefined
    };
};
var deserializeAws_restJson1_1SegmentLocation = function (output, context) {
    return {
        __type: "SegmentLocation",
        Country: output.Country !== undefined && output.Country !== null
            ? deserializeAws_restJson1_1SetDimension(output.Country, context)
            : undefined,
        GPSPoint: output.GPSPoint !== undefined && output.GPSPoint !== null
            ? deserializeAws_restJson1_1GPSPointDimension(output.GPSPoint, context)
            : undefined
    };
};
var deserializeAws_restJson1_1SegmentReference = function (output, context) {
    return {
        __type: "SegmentReference",
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1SegmentResponse = function (output, context) {
    return {
        __type: "SegmentResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        Arn: output.Arn !== undefined && output.Arn !== null ? output.Arn : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Dimensions: output.Dimensions !== undefined && output.Dimensions !== null
            ? deserializeAws_restJson1_1SegmentDimensions(output.Dimensions, context)
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        ImportDefinition: output.ImportDefinition !== undefined && output.ImportDefinition !== null
            ? deserializeAws_restJson1_1SegmentImportResource(output.ImportDefinition, context)
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Name: output.Name !== undefined && output.Name !== null
            ? output.Name
            : undefined,
        SegmentGroups: output.SegmentGroups !== undefined && output.SegmentGroups !== null
            ? deserializeAws_restJson1_1SegmentGroupList(output.SegmentGroups, context)
            : undefined,
        SegmentType: output.SegmentType !== undefined && output.SegmentType !== null
            ? output.SegmentType
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined,
        tags: output.tags !== undefined && output.tags !== null
            ? deserializeAws_restJson1_1MapOf__string(output.tags, context)
            : undefined
    };
};
var deserializeAws_restJson1_1SegmentsResponse = function (output, context) {
    return {
        __type: "SegmentsResponse",
        Item: output.Item !== undefined && output.Item !== null
            ? deserializeAws_restJson1_1ListOfSegmentResponse(output.Item, context)
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null
            ? output.NextToken
            : undefined
    };
};
var deserializeAws_restJson1_1SendUsersMessageResponse = function (output, context) {
    return {
        __type: "SendUsersMessageResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        RequestId: output.RequestId !== undefined && output.RequestId !== null
            ? output.RequestId
            : undefined,
        Result: output.Result !== undefined && output.Result !== null
            ? deserializeAws_restJson1_1MapOfMapOfEndpointMessageResult(output.Result, context)
            : undefined
    };
};
var deserializeAws_restJson1_1SetDimension = function (output, context) {
    return {
        __type: "SetDimension",
        DimensionType: output.DimensionType !== undefined && output.DimensionType !== null
            ? output.DimensionType
            : undefined,
        Values: output.Values !== undefined && output.Values !== null
            ? deserializeAws_restJson1_1ListOf__string(output.Values, context)
            : undefined
    };
};
var deserializeAws_restJson1_1SimpleCondition = function (output, context) {
    return {
        __type: "SimpleCondition",
        EventCondition: output.EventCondition !== undefined && output.EventCondition !== null
            ? deserializeAws_restJson1_1EventCondition(output.EventCondition, context)
            : undefined,
        SegmentCondition: output.SegmentCondition !== undefined && output.SegmentCondition !== null
            ? deserializeAws_restJson1_1SegmentCondition(output.SegmentCondition, context)
            : undefined,
        SegmentDimensions: output.segmentDimensions !== undefined &&
            output.segmentDimensions !== null
            ? deserializeAws_restJson1_1SegmentDimensions(output.segmentDimensions, context)
            : undefined
    };
};
var deserializeAws_restJson1_1StartCondition = function (output, context) {
    return {
        __type: "StartCondition",
        Description: output.Description !== undefined && output.Description !== null
            ? output.Description
            : undefined,
        SegmentStartCondition: output.SegmentStartCondition !== undefined &&
            output.SegmentStartCondition !== null
            ? deserializeAws_restJson1_1SegmentCondition(output.SegmentStartCondition, context)
            : undefined
    };
};
var deserializeAws_restJson1_1TagsModel = function (output, context) {
    return {
        __type: "TagsModel",
        tags: output.tags !== undefined && output.tags !== null
            ? deserializeAws_restJson1_1MapOf__string(output.tags, context)
            : undefined
    };
};
var deserializeAws_restJson1_1Template = function (output, context) {
    return {
        __type: "Template",
        Name: output.Name !== undefined && output.Name !== null
            ? output.Name
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1TemplateConfiguration = function (output, context) {
    return {
        __type: "TemplateConfiguration",
        EmailTemplate: output.EmailTemplate !== undefined && output.EmailTemplate !== null
            ? deserializeAws_restJson1_1Template(output.EmailTemplate, context)
            : undefined,
        PushTemplate: output.PushTemplate !== undefined && output.PushTemplate !== null
            ? deserializeAws_restJson1_1Template(output.PushTemplate, context)
            : undefined,
        SMSTemplate: output.SMSTemplate !== undefined && output.SMSTemplate !== null
            ? deserializeAws_restJson1_1Template(output.SMSTemplate, context)
            : undefined,
        VoiceTemplate: output.VoiceTemplate !== undefined && output.VoiceTemplate !== null
            ? deserializeAws_restJson1_1Template(output.VoiceTemplate, context)
            : undefined
    };
};
var deserializeAws_restJson1_1TemplateResponse = function (output, context) {
    return {
        __type: "TemplateResponse",
        Arn: output.Arn !== undefined && output.Arn !== null ? output.Arn : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        DefaultSubstitutions: output.DefaultSubstitutions !== undefined &&
            output.DefaultSubstitutions !== null
            ? output.DefaultSubstitutions
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        TemplateDescription: output.TemplateDescription !== undefined &&
            output.TemplateDescription !== null
            ? output.TemplateDescription
            : undefined,
        TemplateName: output.TemplateName !== undefined && output.TemplateName !== null
            ? output.TemplateName
            : undefined,
        TemplateType: output.TemplateType !== undefined && output.TemplateType !== null
            ? output.TemplateType
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined,
        tags: output.tags !== undefined && output.tags !== null
            ? deserializeAws_restJson1_1MapOf__string(output.tags, context)
            : undefined
    };
};
var deserializeAws_restJson1_1TemplateVersionResponse = function (output, context) {
    return {
        __type: "TemplateVersionResponse",
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        DefaultSubstitutions: output.DefaultSubstitutions !== undefined &&
            output.DefaultSubstitutions !== null
            ? output.DefaultSubstitutions
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        TemplateDescription: output.TemplateDescription !== undefined &&
            output.TemplateDescription !== null
            ? output.TemplateDescription
            : undefined,
        TemplateName: output.TemplateName !== undefined && output.TemplateName !== null
            ? output.TemplateName
            : undefined,
        TemplateType: output.TemplateType !== undefined && output.TemplateType !== null
            ? output.TemplateType
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1TemplateVersionsResponse = function (output, context) {
    return {
        __type: "TemplateVersionsResponse",
        Item: output.Item !== undefined && output.Item !== null
            ? deserializeAws_restJson1_1ListOfTemplateVersionResponse(output.Item, context)
            : undefined,
        Message: output.Message !== undefined && output.Message !== null
            ? output.Message
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null
            ? output.NextToken
            : undefined,
        RequestID: output.RequestID !== undefined && output.RequestID !== null
            ? output.RequestID
            : undefined
    };
};
var deserializeAws_restJson1_1TemplatesResponse = function (output, context) {
    return {
        __type: "TemplatesResponse",
        Item: output.Item !== undefined && output.Item !== null
            ? deserializeAws_restJson1_1ListOfTemplateResponse(output.Item, context)
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null
            ? output.NextToken
            : undefined
    };
};
var deserializeAws_restJson1_1TreatmentResource = function (output, context) {
    return {
        __type: "TreatmentResource",
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        MessageConfiguration: output.MessageConfiguration !== undefined &&
            output.MessageConfiguration !== null
            ? deserializeAws_restJson1_1MessageConfiguration(output.MessageConfiguration, context)
            : undefined,
        Schedule: output.Schedule !== undefined && output.Schedule !== null
            ? deserializeAws_restJson1_1Schedule(output.Schedule, context)
            : undefined,
        SizePercent: output.SizePercent !== undefined && output.SizePercent !== null
            ? output.SizePercent
            : undefined,
        State: output.State !== undefined && output.State !== null
            ? deserializeAws_restJson1_1CampaignState(output.State, context)
            : undefined,
        TemplateConfiguration: output.TemplateConfiguration !== undefined &&
            output.TemplateConfiguration !== null
            ? deserializeAws_restJson1_1TemplateConfiguration(output.TemplateConfiguration, context)
            : undefined,
        TreatmentDescription: output.TreatmentDescription !== undefined &&
            output.TreatmentDescription !== null
            ? output.TreatmentDescription
            : undefined,
        TreatmentName: output.TreatmentName !== undefined && output.TreatmentName !== null
            ? output.TreatmentName
            : undefined
    };
};
var deserializeAws_restJson1_1VoiceChannelResponse = function (output, context) {
    return {
        __type: "VoiceChannelResponse",
        ApplicationId: output.ApplicationId !== undefined && output.ApplicationId !== null
            ? output.ApplicationId
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        Enabled: output.Enabled !== undefined && output.Enabled !== null
            ? output.Enabled
            : undefined,
        HasCredential: output.HasCredential !== undefined && output.HasCredential !== null
            ? output.HasCredential
            : undefined,
        Id: output.Id !== undefined && output.Id !== null ? output.Id : undefined,
        IsArchived: output.IsArchived !== undefined && output.IsArchived !== null
            ? output.IsArchived
            : undefined,
        LastModifiedBy: output.LastModifiedBy !== undefined && output.LastModifiedBy !== null
            ? output.LastModifiedBy
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        Platform: output.Platform !== undefined && output.Platform !== null
            ? output.Platform
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined
    };
};
var deserializeAws_restJson1_1VoiceTemplateResponse = function (output, context) {
    return {
        __type: "VoiceTemplateResponse",
        Arn: output.Arn !== undefined && output.Arn !== null ? output.Arn : undefined,
        Body: output.Body !== undefined && output.Body !== null
            ? output.Body
            : undefined,
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? output.CreationDate
            : undefined,
        DefaultSubstitutions: output.DefaultSubstitutions !== undefined &&
            output.DefaultSubstitutions !== null
            ? output.DefaultSubstitutions
            : undefined,
        LanguageCode: output.LanguageCode !== undefined && output.LanguageCode !== null
            ? output.LanguageCode
            : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? output.LastModifiedDate
            : undefined,
        TemplateDescription: output.TemplateDescription !== undefined &&
            output.TemplateDescription !== null
            ? output.TemplateDescription
            : undefined,
        TemplateName: output.TemplateName !== undefined && output.TemplateName !== null
            ? output.TemplateName
            : undefined,
        TemplateType: output.TemplateType !== undefined && output.TemplateType !== null
            ? output.TemplateType
            : undefined,
        Version: output.Version !== undefined && output.Version !== null
            ? output.Version
            : undefined,
        VoiceId: output.VoiceId !== undefined && output.VoiceId !== null
            ? output.VoiceId
            : undefined,
        tags: output.tags !== undefined && output.tags !== null
            ? deserializeAws_restJson1_1MapOf__string(output.tags, context)
            : undefined
    };
};
var deserializeAws_restJson1_1WaitActivity = function (output, context) {
    return {
        __type: "WaitActivity",
        NextActivity: output.NextActivity !== undefined && output.NextActivity !== null
            ? output.NextActivity
            : undefined,
        WaitTime: output.WaitTime !== undefined && output.WaitTime !== null
            ? deserializeAws_restJson1_1WaitTime(output.WaitTime, context)
            : undefined
    };
};
var deserializeAws_restJson1_1WaitTime = function (output, context) {
    return {
        __type: "WaitTime",
        WaitFor: output.WaitFor !== undefined && output.WaitFor !== null
            ? output.WaitFor
            : undefined,
        WaitUntil: output.WaitUntil !== undefined && output.WaitUntil !== null
            ? output.WaitUntil
            : undefined
    };
};
var deserializeMetadata = function (output) { return ({
    httpStatusCode: output.statusCode,
    httpHeaders: output.headers,
    requestId: output.headers["x-amzn-requestid"]
}); };
// Collect low-level response body stream to Uint8Array.
var collectBody = function (streamBody, context) {
    if (streamBody === void 0) { streamBody = new Uint8Array(); }
    if (streamBody instanceof Uint8Array) {
        return Promise.resolve(streamBody);
    }
    return (context.streamCollector(streamBody) || Promise.resolve(new Uint8Array()));
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function (streamBody, context) {
    return collectBody(streamBody, context).then(function (body) { return context.utf8Encoder(body); });
};
var isSerializableHeaderValue = function (value) {
    return value !== undefined &&
        value !== "" &&
        (!Object.getOwnPropertyNames(value).includes("length") ||
            value.length != 0) &&
        (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function (streamBody, context) {
    return collectBodyString(streamBody, context).then(function (encoded) {
        if (encoded.length) {
            return JSON.parse(encoded);
        }
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */
var loadRestJsonErrorCode = function (output, data) {
    var findKey = function (object, key) {
        return Object.keys(object).find(function (k) { return k.toLowerCase() === key.toLowerCase(); });
    };
    var sanitizeErrorCode = function (rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) {
            cleanValue = cleanValue.split(":")[0];
        }
        if (cleanValue.indexOf("#") >= 0) {
            cleanValue = cleanValue.split("#")[1];
        }
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) {
        return sanitizeErrorCode(output.headers[headerKey]);
    }
    if (data.code !== undefined) {
        return sanitizeErrorCode(data.code);
    }
    if (data["__type"] !== undefined) {
        return sanitizeErrorCode(data["__type"]);
    }
    return "";
};
//# sourceMappingURL=Aws_restJson1_1.js.map